<template>
    <div class="voiceEditBtn">
        <div class="voiceBtn-container" :style="'height: 190px'">
            <div class="miniMap-container" @click="c()">
                <canvas id="canvas1" :width="minimapWidth" height="30px"></canvas>
                <div id="wave1" :style="'width:'+nowWidth+';height: 30px;overflow: hidden'">
                    <canvas id="canvas2" :width="minimapWidth" height="30px"></canvas>
                </div>
            </div>
            <div id="audioWord" style="width: 100%;height: 30px;"></div>
            <div style="width:100%;background:rgba(0,0,0,0.3)" id="audioContainer">
                <div class="wave-container" :style="'position: relative;width:100%; padding: 0 20px; box-sizing: border-box;'">
                    <div class="wave-form" id="audioPlayer" style="width: 100%;"></div>
                    <div :style="'padding: 0 20px;top:102px'" id="audioTimeLine"></div>
                </div>
                <div class="bottom-mask" :style="'height:30px'"></div>
            </div>
            <audio id="audioId" src=""></audio>
        </div>

        <div class="btnEdit-contianer">
            <div :style="'width: 100%;padding: 0px 60px'" class="btn-container">
                <div class="left-btn">
                    <div @click="delArticle1" class="el-button" style="padding: 0px!important;border: none;">删除</div>
                    <div @click="resumeArticle1" class="el-button" style="margin-right: 30px;padding: 0px!important;border: none;">恢复</div>
                    <div class="notice">
                        <img src="../assets/previewAlertIcon.png">
                        <span>选中文字或音轨后进行剪辑</span>
                    </div>
                </div>
                <div class="mid-btn">
                    <img class="leftArrow" @click="skipStart" src="../assets/wLeftArrow.png">
                    <img v-if="canPlay==false&&isPlay==false" style="cursor: pointer" @click="playAudio();isPlay=!isPlay" src="../assets/playBtn.png">
                    <img v-if="canPlay==true" src="../assets/canPlayBtn.png">
                    <img v-if="canPlay==false&&isPlay==true" style="cursor: pointer" @click="playAudio();isPlay=!isPlay" src="../assets/pauseBtn.png">
                    <img class="rightArrow" @click="skipEnd" src="../assets/wRightArrow.png">
                </div>
                <div class="right-btn">
                    <div style="border: none" @click="compose" class="el-button">
                        <img src="../assets/composeIcon.png">
                        <span>合成</span>
                    </div>
                </div>

            </div>
        </div>
        
    </div>
    
</template>

<script>
// import bus from "../../bus.js"
// import moment from "moment";

export default {
    props: ['editConfig'],
    data() {
        return {
            leftPadding: '50px',
            wavesurfer: null,
            isPlay: false,
            audio: null,
            time: null,
            audioUrl: '',
            canPlay: true,
            isAudioPlayer: false,
            left: 0,
            duration: 0,
            context: null,
            buffer: [],
            clipTime: [
                {type:'del',startTime: '5',endTime: '7'},
                {type:'del',startTime: '15',endTime: '20'},
                {type:'region',startTime: '25',endTime: '26',regionStart: '0',regionEnd: '3'},
                {type:'region',startTime: '35',endTime: '40',regionStart: '10',regionEnd: '13'}
            ],
            clipDate: [

            ],
            regionPlay: false,
            endTime1: '',
            regionEnd1: '',
            nowTimeStr: '',
            content: '',
            notDel: false,
            zmContent: '',
            zmRegion: null,
            playdbl: false,
            halfNum: '',
            note: [
                {time: 0.02, value: 121},
                {time: 0.03, value: 127},
                {time: 0.22, value: 120},
                {time: 0.03, value: 119}
            ],
            oldNum1: 99999999,
            oldIndex: 9999999,
            regionLeft: '',
            regionWidth: '',
            enableResize: null,
            totalDuration: '',
            maxSec: '',
            nowMax: false,
            oneClick: false,
            twoClick: false,
            zmBg: 0,
            zmEd: 0,
            isZm: false,
            bottomHeight: '284px',
            mapHeight: '48',
            mapTop: '114px',
            btnPadding: '10px 0 10px 0',
            canvasHeight: '142',
            canvasPadding: '0 50px',
            canvasLeft: '50px',
            minimapWidth: '0px',
            nowWidth: 0,
            totalDuration1: 0,
            totalDurationSave: 0,
            totalDurationSave1: 0,
            saveCurrentTimeClick: 0,
            saveCurrentTimeClick1: 0,
            changeClientWidth: 0,
            arr12: '',
            arr13: '',
            arr12Save: '',
            arr13Save: '',
            audioBuffer: '',
            audioBufferDate: '',
            copyRegionArr: [],
            config: {},
            resultData: [],
            wordList: [],
            saveWordList: []
        }
    },
    methods: {
        delArticle1() {
            this.$emit('delArticle')
        },
        resumeArticle1() {
            this.$emit('resumeArticle')
        },
        compose() {
            this.$emit('compose')
        },
        init: function() {
            // console.log(this.config)
            this.config.wordContent = JSON.parse(JSON.parse(this.config.wordContent))
            var that = this;
            this.config.wordContent.forEach(function(val,index){
                that.resultData = [];
                val.index = index;
                val.wordsResultList.forEach(function(el,key){
                    if(el.wordsName!=''){
                        var bg = Number(val.bg) + Number(el.wordBg)*1;
                        var ed = Number(val.bg) + Number(el.wordEd)*1;
                        that.resultData.push('<span data-index="'+index+'" data-index1="'+key+'" data-bg="'+bg+'" data-ed="'+ed+'">'+el.wordsName+'</span>')
                    }
                })
                var strResult = that.resultData.join('')
                that.wordList.push('<span data-index="'+index+'" data-bg="'+val.bg+'" data-ed="'+val.ed+'">'+strResult+'</span>');
                that.saveWordList.push({
                    bg: val.bg,
                    ed: val.ed
                })
            })
            // console.log(123)
            that.wordList = that.wordList.join('');
            $('#'+this.config.el).append(that.wordList)
            var len11 = $('#'+this.config.el+' > span').length-1;
            var len12 = $('#'+this.config.el+' > span:eq('+len11+') > span').length-1;
            var maxSec = $('#'+this.config.el+' > span:eq('+len11+') > span:eq('+len12+')').attr('data-ed');
            // console.log(123)
            // console.log(this.config.edit_result)
            if(this.config.edit_result!=''&&this.config.edit_result!=null&&this.config.edit_result!=undefined){
                var editResult = JSON.parse(this.config.edit_result);
                console.log(123)
                if(editResult.clipDate!=''&&editResult.clipDate!=undefined&&editResult.clipDate!=null){
                    editResult.clipDate.forEach(function(val,index){
                        var len = val.arr.length;
                        if(len == 2){
                            var num1 = val.arr[0].fatherIndex;
                            var num2 = val.arr[1].fatherIndex;
                            var num1Index = val.arr[0].index;
                            var num2Index = val.arr[1].index;
                            if(num1 == num2){
                                for(var i=num1Index; i<Number(num2Index)+1; i++){
                                    $('#'+that.config.el+' > span:eq('+num1+') > span:eq('+i+')').addClass('on');
                                    that.config.content[num1].result = $('#'+that.config.el+' > span:eq('+num1+')').html();
                                }
                            }else{
                                for(var i=num1; i<Number(num2)+1; i++){
                                    var len1 = $('#'+that.config.el+' > span:eq('+i+') > span').length;
                                    if(i==num1){
                                        for(var j=num1Index; j<len1; j++){
                                            $('#'+that.config.el+' > span:eq('+i+') > span:eq('+j+')').addClass('on');
                                            that.config.content[i].result = $('#'+that.config.el+' > span:eq('+i+')').html();
                                        }
                                    }else if(i==num2){
                                        for(var j=0; j<Number(num2Index)+1; j++){
                                            $('#'+that.config.el+' > span:eq('+i+') > span:eq('+j+')').addClass('on');
                                            that.config.content[i].result = $('#'+that.config.el+' > span:eq('+i+')').html();
                                        }
                                    }else{
                                        for(var j=0; j<len1; j++){
                                            $('#'+that.config.el+' > span:eq('+i+') > span:eq('+j+')').addClass('on');
                                            that.config.content[i].result = $('#'+that.content.el+' > span:eq('+i+')').html();
                                        }
                                    }
                                }
                            }
                        }else{
                            val.arr.forEach(function(el,key){
                                $('#'+that.config.el+' > span:eq('+el.fatherIndex+') > span:eq('+el.index+')').addClass('on');
                                that.config.content[el.fatherIndex].result = $('#'+that.config.el+' > span:eq('+el.fatherIndex+')').html();
                            })
                        }
                    })
                    console.log(123)
                    console.log(that.saveWordList)
                    that.$emit('setContent',{
                        wordList: that.saveWordList
                    })

                    that.setClipDateEvent({clipDate: editResult.clipDate});

                    that.maxSecEvent({maxSec: maxSec});

                    that.submitContentEvent({
                        content: that.config.content,
                        leftPadding: that.leftPadding
                    });

                    $('#'+that.config.el+' > span').dblclick(function(){
                        var bg = $(this).attr('data-bg');
                        var ed = $(this).attr('data-ed');
                        var index = $(this).attr('data-index');
                        that.dblPlayEvent({
                            bg: bg,
                            ed: ed,
                            index: index,
                            playdbl: true
                        });
                    })
                }
            }else{
                that.$emit('setContent',{
                    wordList: that.saveWordList
                })

                that.maxSecEvent({
                    maxSec: maxSec
                });

                that.submitContentEvent({
                    content: that.config.content,
                    leftPadding: that.leftPadding
                });

                $('#'+that.config.el+' > span').dblclick(function(){
                    var bg = $(this).attr('data-bg');
                    var ed = $(this).attr('data-ed');
                    var index = $(this).attr('data-index');
                    that.dblPlayEvent({
                        bg: bg,
                        ed: ed,
                        index: index,
                        playdbl: true
                    });
                })
            }
        },
        delArticle(callback) {
            // Backspace删除事件
            var that = this;
            this.saveWordList = [];
            var indexArr = [];
            if(window.getSelection().getRangeAt(0).commonAncestorContainer.textContent.length!=1){
                if(window.getSelection().getRangeAt(0).commonAncestorContainer.className=='el-input'){
                    return false;
                }else if(window.getSelection().getRangeAt(0).commonAncestorContainer.data!=''&&window.getSelection().getRangeAt(0).commonAncestorContainer.data!=undefined&&window.getSelection().getRangeAt(0).commonAncestorContainer.data!=null){
                    return false;
                }
                that.$emit('setLoading',{
                    loading: true
                })
                setTimeout(function(){
                    var container = window.getSelection().getRangeAt(0).cloneContents();
                    var container1 = '';
                    $('#e2').html('');
                    $('#e2').append(container);
                    var lineArr = [];
                    if($('#e2 > span > span').length!=0){
                        var len = $('#e2 > span > span').length;
                        for(var i=0; i<len; i++){
                            var bg = $('#e2 > span > span:eq(0)').attr('data-bg');
                            var ed = $('#e2 > span > span:eq('+i+')').attr('data-ed');
                            var fatherIndex = $('#e2 > span > span:eq('+i+')').attr('data-index');
                            var index = $('#e2 > span > span:eq('+i+')').attr('data-index1');
                            lineArr.push({
                                fatherIndex: fatherIndex,
                                index: index
                            })
                        }
                    }else{
                        var len = $('#e2 span').length;
                        for(var i=0; i<len; i++){
                            var bg = $('#e2 span:eq(0)').attr('data-bg');
                            var ed = $('#e2 span:eq('+i+')').attr('data-ed');
                            var fatherIndex = $('#e2 span:eq('+i+')').attr('data-index');
                            var index = $('#e2 span:eq('+i+')').attr('data-index1');
                            lineArr.push({
                                fatherIndex: fatherIndex,
                                index: index
                            })
                        }
                    }
                    var ranString = 'ranString' + Math.random();
                    lineArr.forEach(function(el,index){
                        $('#'+that.config.el+' > span:eq('+el.fatherIndex+') > span:eq('+el.index+')').addClass('on')
                        $('#'+that.config.el+' > span:eq('+el.fatherIndex+') > span:eq('+el.index+')').addClass(ranString)
                    })
                    if(window.getSelection().getRangeAt(0).commonAncestorContainer.tagName == "SPAN"){
                        container1 = window.getSelection().getRangeAt(0).commonAncestorContainer.outerHTML;
                        var index1 = $(container1).attr('data-index');
                        var len1 = $('#'+that.config.el+' > span').length;
                        var arr0 = [];
                        for(var x=0; x<len1; x++){
                            if($('#'+that.config.el+' > span:eq('+x+')').attr('data-index') == index1){
                                var len2 = $('#'+that.config.el+' > span:eq('+x+') > span').length;
                                for( var y=0; y<len2; y++){
                                    if($('#'+that.config.el+' > span:eq('+x+') > span:eq('+y+')').hasClass(ranString)){
                                        arr0.push({
                                            fatherIndex: index1,
                                            index: y,
                                            bg: $('#'+that.config.el+' > span:eq('+x+') > span:eq('+y+')').attr('data-bg'),
                                            maxBg: $('#'+that.config.el+' > span:eq('+x+')').attr('data-bg'),
                                            ed: $('#'+that.config.el+' > span:eq('+x+') > span:eq('+y+')').attr('data-ed'),
                                            maxEd: $('#'+that.config.el+' > span:eq('+x+')').attr('data-ed')
                                        });
                                    }
                                }
                            }
                        }
                        that.setDelInfoEvent({
                            type: 'del',
                            bg: Number(bg)/1000,
                            ed: Number(ed)/1000,
                            arr0: arr0
                        });
                    }else{
                        container1 = $('#e2').html();
                        var len1 = $(container1).length - 1;
                        var startIndex = $(container1)[0].dataset.index;
                        var endIndex = $(container1)[len1].dataset.index;
                        var arr0 = [];
                        for(var i=0; i<$(container1).length; i++){
                            var nowIndex = $(container1)[i].dataset.index;
                            var len2 = $('#'+that.config.el+' > span:eq('+nowIndex+') > span').length;
                            for( var y=0; y<len2; y++){
                                if($('#'+that.config.el+' > span:eq('+nowIndex+') > span:eq('+y+')').hasClass(ranString)){
                                    arr0.push({
                                        fatherIndex: nowIndex,
                                        index: y,
                                        bg: $('#'+that.config.el+' > span:eq('+nowIndex+') > span:eq('+y+')').attr('data-bg'),
                                        maxBg: $('#'+that.config.el+' > span:eq('+nowIndex+')').attr('data-bg'),
                                        ed: $('#'+that.config.el+' > span:eq('+nowIndex+') > span:eq('+y+')').attr('data-ed'),
                                        maxEd: $('#'+that.config.el+' > span:eq('+nowIndex+')').attr('data-ed')
                                    });
                                }
                            }
                        }
                        that.setDelInfoEvent({
                            type: 'del',
                            bg: Number(bg)/1000,
                            ed: Number(ed)/1000,
                            arr0: arr0
                        });
                    }
                    var pasteLength = $('#'+that.config.el+' > span').length;
                    for(var i=0; i<pasteLength; i++){
                        var index = $('#'+that.config.el+' > span:eq('+i+')').attr('data-index');
                        var html = $('#'+that.config.el+' > span:eq('+i+')').html();
                        var bg = $('#'+that.config.el+' > span:eq('+i+')').attr('data-bg');
                        var ed = $('#'+that.config.el+' > span:eq('+i+')').attr('data-ed');
                        if(index!=undefined){
                            indexArr.push({
                                index: index,
                                html: html
                            })
                            that.saveWordList.push({
                                bg: bg,
                                ed: ed
                            })
                        }
                        that.config.content[i].result = '';
                    }
                    indexArr.forEach(function(val,index){
                        that.config.content[val.index].result = val.html
                    })
                    setTimeout(function(){
                        that.$emit('setLoading',{
                            loading: false
                        })
                        that.$emit('setContent',{
                            wordList: that.saveWordList
                        })
                        that.submitContentEvent({
                            content: that.config.content,
                            leftPadding: '50px'
                        });
                    },1500)
                },500)
            }else{
                that.$emit('setLoading',{
                    loading: true
                })
                setTimeout(function(){
                    var container = window.getSelection().getRangeAt(0).commonAncestorContainer.parentNode.outerHTML
                    var bg = $(container).attr('data-bg');
                    var ed = $(container).attr('data-ed');
                    var index = $(container).attr('data-index');
                    var index1 = $(container).attr('data-index1');
                    var pasteLength = $('#'+that.config.el+' > span').length;
                    var randomString = 'randomString' + Math.random();
                    $('#'+that.config.el+' > span:eq('+index+') > span:eq('+index1+')').addClass('on');
                    $('#'+that.config.el+' > span:eq('+index+') > span:eq('+index1+')').addClass(randomString);
                    var arr0 = [];
                    var len2 = $('#'+that.config.el+' > span:eq('+index+') > span').length;
                    for(var z=0; z<len2; z++){
                        if($('#'+that.config.el+' > span:eq('+index+') > span:eq('+z+')').hasClass(randomString)){
                            arr0.push({
                                fatherIndex: index,
                                index: z,
                                bg: bg,
                                maxBg: '',
                                ed: ed,
                                maxEd: ''
                            });
                        }
                    }

                    that.setDelInfoEvent({
                        type: 'del',
                        bg: Number(bg)/1000,
                        ed: Number(ed)/1000,
                        arr0: arr0
                    });

                    for(var i=0; i<pasteLength; i++){
                        var index = $('#'+that.config.el+' > span:eq('+i+')').attr('data-index');
                        var html = $('#'+that.config.el+' > span:eq('+i+')').html();
                        var bg = $('#'+that.config.el+' > span:eq('+i+')').attr('data-bg');
                        var ed = $('#'+that.config.el+' > span:eq('+i+')').attr('data-ed');
                        that.config.content[index].result = html;
                        that.saveWordList.push({
                            bg: bg,
                            ed: ed
                        })
                    }
                    setTimeout(function(){
                        that.$emit('setLoading',{
                            loading: false
                        })
                        that.$emit('setContent',{
                            wordList: that.saveWordList
                        })
                        that.submitContentEvent({
                            content: that.config.content,
                            leftPadding: '50px'
                        });
                    },1500)
                },500)
            }
        },
        resumeArticle(callback) {
            // ctrl + Z 恢复删除时间段
            var that = this;
            this.saveWordList = [];
            var indexArr = [];
            that.$emit('setLoading',{
                loading: true
            })
            setTimeout(function(){
                if(window.getSelection().getRangeAt(0).commonAncestorContainer.textContent.length!=1){
                    var container = window.getSelection().getRangeAt(0).cloneContents();
                    var container1 = '';
                    $('#e2').html('');
                    $('#e2').append(container);
                    var arr2 = [];
                    var lineArr = [];
                    if($('#e2 > span > span').length!=0){
                        var len = $('#e2 > span > span').length;
                        for(var i=0; i<len; i++){
                            var bg = $('#e2 > span > span:eq(0)').attr('data-bg');
                            var ed = $('#e2 > span > span:eq('+i+')').attr('data-ed');
                            var hasClass = $('#e2 > span > span:eq('+i+')').hasClass('on');
                            if(hasClass){
                                var fatherIndex = $('#e2 > span > span:eq('+i+')').attr('data-index');
                                var index = $('#e2 > span > span:eq('+i+')').attr('data-index1');
                            }else{
                                var fatherIndex = '';
                                var index = '';
                            }
                            if(fatherIndex!=''&&fatherIndex!=null&&fatherIndex!=undefined){
                                lineArr.push({
                                    fatherIndex: fatherIndex,
                                    index: index
                                })
                            }
                        }
                    }else{
                        var len = $('#e2 span').length;
                        for(var i=0; i<len; i++){
                            var bg = $('#e2 span:eq(0)').attr('data-bg');
                            var ed = $('#e2 span:eq('+i+')').attr('data-ed');
                            var hasClass = $('#e2 span:eq('+i+')').hasClass('on');
                            if(hasClass){
                                var fatherIndex = $('#e2 span:eq('+i+')').attr('data-index');
                                var index = $('#e2 span:eq('+i+')').attr('data-index1');
                            }else{
                                var fatherIndex = '';
                                var index = '';
                            }
                            if(fatherIndex!=''&&fatherIndex!=null&&fatherIndex!=undefined){
                                lineArr.push({
                                    fatherIndex: fatherIndex,
                                    index: index
                                })
                            }
                        }
                    }
                    if(lineArr.length==0){
                        that.$emit('setLoading',{
                            loading: false
                        })
                        return false;
                    }
                    var len9 = lineArr.length-1;
                    var bg = $('#'+that.config.el+' > span:eq('+lineArr[0].fatherIndex+') > span:eq('+lineArr[0].index+')').attr('data-bg');
                    var ed = $('#'+that.config.el+' > span:eq('+lineArr[len9].fatherIndex+') > span:eq('+lineArr[len9].index+')').attr('data-ed');
                    for(var i=0; i<lineArr.length; i++){
                        $('#'+that.config.el+' > span:eq('+lineArr[i].fatherIndex+') > span:eq('+lineArr[i].index+')').removeClass('on')
                    }
                    // callback.resumeDel({
                    //     bg: bg,
                    //     ed: ed,
                    //     arr: lineArr,
                    //     clipDate: callback.clipDate
                    // })
                    that.resumeDelEvent({
                        bg: bg,
                        ed: ed,
                        arr: lineArr,
                        clipDate: callback.clipDate
                    });
                    var indexArr = [];
                    that.saveWordList = [];
                    var pasteLength = $('#'+that.config.el+' > span').length;
                    for(var i=0; i<pasteLength; i++){
                        var index = $('#'+that.config.el+' > span:eq('+i+')').attr('data-index');
                        var html = $('#'+that.config.el+' > span:eq('+i+')').html();
                        var bg = $('#'+that.config.el+' > span:eq('+i+')').attr('data-bg');
                        var ed = $('#'+that.config.el+' > span:eq('+i+')').attr('data-ed');
                        if(index!=undefined){
                            indexArr.push({
                                index: index,
                                html: html
                            })
                            that.saveWordList.push({
                                bg: bg,
                                ed: ed
                            })
                        }
                        that.config.content[i].result = '';
                    }
                    indexArr.forEach(function(val,index){
                        that.config.content[val.index].result = val.html
                    })
                    setTimeout(function(){
                        // callback.loading(false);
                        that.$emit('setLoading',{
                            loading: false
                        })

                        that.$emit('setContent',{
                            wordList: that.saveWordList
                        })
                        that.submitContentEvent({
                            content: that.config.content,
                            leftPadding: '50px'
                        });

                        // callback.submitContent({
                        //     content: that.config.content,
                        //     leftPadding: '50px',
                        //     wordList: saveWordList
                        // })
                    },1500)
                }else{
                    var container = window.getSelection().getRangeAt(0).commonAncestorContainer.parentNode.outerHTML
                    var bg = $(container).attr('data-bg');
                    var ed = $(container).attr('data-ed');
                    var index = $(container).attr('data-index');
                    var index1 = $(container).attr('data-index1');
                    var arr0 = [];
                    arr0.push({
                        fatherIndex: index,
                        index: index1
                    })
                    $('#'+that.config.el+' > span:eq('+index+') > span:eq('+index1+')').removeClass('on');
                    // callback.resumeDel({
                    //     bg: bg,
                    //     ed: ed,
                    //     arr: arr0,
                    //     clipDate: callback.clipDate
                    // })
                    that.resumeDelEvent({
                        bg: bg,
                        ed: ed,
                        arr: arr0,
                        clipDate: callback.clipDate
                    });
                    var indexArr = [];
                    that.saveWordList = [];
                    var pasteLength = $('#'+that.config.el+' > span').length;
                    for(var i=0; i<pasteLength; i++){
                        var index = $('#'+that.config.el+' > span:eq('+i+')').attr('data-index');
                        var html = $('#'+that.config.el+' > span:eq('+i+')').html();
                        var bg = $('#'+that.config.el+' > span:eq('+i+')').attr('data-bg');
                        var ed = $('#'+that.config.el+' > span:eq('+i+')').attr('data-ed');
                        if(index!=undefined){
                            indexArr.push({     
                                index: index,
                                html: html
                            })
                            that.saveWordList.push({
                                bg: bg,
                                ed: ed
                            })
                        }
                        that.config.content[i].result = '';
                    }
                    indexArr.forEach(function(val,index){
                        that.config.content[val.index].result = val.html
                    })
                    setTimeout(function(){
                        that.$emit('setLoading',{
                            loading: false
                        })
                        that.$emit('setContent',{
                            wordList: that.saveWordList
                        })
                        that.submitContentEvent({
                            content: that.config.content,
                            leftPadding: '50px'
                        });
                    },1500)
                }
            },500)
        },
        saveArticle(callback) {
            var that = this;
            that.$emit('setLoading',{
                loading: true
            })
            var resultArr = [];
            var resultArr1 = [];
            var resultArr2 = [];
            var resultArr3 = {};
            var arr = [];
            var minBg = 0;
            var maxBg = 0;
            var len = $('#'+that.config.el+' > span').length;
            for(var i=0; i<len; i++){
                if($('#'+that.config.el+' > span:eq('+i+')').text()!=''){
                    arr.push($('#'+that.config.el+' > span:eq('+i+')').html())
                }
            }
            var length = arr.length;
            for(var j=0; j<length; j++){
                var subArr = [];
                var subArr1 = [];
                var arr1 = [];
                var len1 = $(arr[j]).length
                var bg = $(arr[j]).attr('data-bg');
                var ed = $(arr[j]).attr('data-ed');
                var oldIndex = $(arr[j]).attr('data-index');
                var val = $(arr[j]).text();
                var span = $(arr[j]).find('span')
                var newHtml = ''
                for(var x=0; x<len1; x++){
                    if($(span.prevObject[x]).hasClass('on')){
                        var sbbg = 0;
                        var sbed = 0;
                        var sbval = '';
                        subArr.push({
                            bg: sbbg,
                            ed: sbed,
                            val: sbval
                        })
                        newHtml += sbval
                    }else{
                        var sbbg = span.prevObject[x].dataset.bg;
                        var sbed = span.prevObject[x].dataset.ed;
                        var index = span.prevObject[x].dataset.index;
                        var index1 = span.prevObject[x].dataset.index1;
                        var sbval = span.prevObject[x].innerText;
                        subArr.push({
                            bg: sbbg,
                            ed: sbed,
                            val: sbval
                        })
                        subArr1.push({
                            wordBg: sbbg,
                            wordEd: sbed,
                            wordsName: sbval
                        })
                        newHtml += sbval
                    }
                }
                if(subArr.length == 0){
                    resultArr.push({
                        bg: 0,
                        ed: 0,
                        val: '',
                        sub: subArr
                    })
                }else{
                    resultArr.push({
                        bg: subArr[0].bg,
                        ed: subArr[subArr.length-1].ed,
                        val: newHtml,
                        sub: subArr
                    })
                }
                if(subArr1.length == 0){
                    console.log(1)
                }else{
                    resultArr1.push({
                        bg: subArr1[0].wordBg,
                        ed: subArr1[subArr1.length-1].wordEd,
                        index: oldIndex,
                        onebest: newHtml,
                        wordsResultList: subArr1
                    })
                    resultArr2.push({
                        bg: subArr1[0].wordBg/10,
                        ed: subArr1[subArr1.length-1].wordEd/10,
                        result: newHtml
                    })
                }
            }

            var oldIndex = 0;
            var index2 = 0;
            var arr8 = [];
            var arr9 = [];
            var started = 0;
            var lastStarted = 0;
            var ended = 0;
            var canOutput = false;
            var len6 = resultArr.length-1;
            var len7 = resultArr[len6].sub.length-1;
            resultArr.forEach(function(el,key){
                el.sub.forEach(function(e,index){
                    if(e.bg==0&&e.ed==0){
                        lastStarted=0;
                        if(canOutput){
                            arr8.push({
                                bg: started,
                                ed: ended,
                                index: index2
                            })
                            index2++;
                            canOutput = false;
                        }
                    }else{
                        if(lastStarted==0){
                            started=e.bg;
                            lastStarted=e.bg;
                        }
                        ended = e.ed;
                        canOutput = true;
                        if(key==len6&&index==len7&&index2!=oldIndex){
                            arr8.push({
                                bg: started,
                                ed: ended,
                                index: index2
                            })
                            oldIndex = index2;
                        }else if(key==len6&&index==len7&&index2==oldIndex){
                            arr8.push({
                                bg: started,
                                ed: ended,
                                index: index2
                            })
                            oldIndex = index2;
                        }
                    }
                })
            })

            
            if(arr8.length==0){
                started = resultArr[0].sub[0].bg;
                ended = resultArr[len6].sub[len7].ed
                arr8.push({
                    bg: started,
                    ed: ended,
                    index: 0
                })
                oldIndex = 0;
            }

            callback.clipDate.forEach(function(val,index){
                if(val.blank == 1){
                    arr9.push({
                        bg: val.startTime,
                        ed: val.endTime
                    })
                }
            })

            resultArr3.public_result = resultArr1;
            resultArr3.result = resultArr2;
            resultArr3.clipDate = callback.clipDate;
            resultArr3.timeLine = arr8;
            resultArr3.blankArea = arr9;
            that.$emit('setLoading',{
                loading: false
            })
            var result = JSON.stringify(resultArr3);
            callback.result(result);
        },
        stopaudioEvent() {
            var that = this;
            if(that.isAudioPlayer){
                that.audio.pause();
            }
            that.wavesurfer.pause()
            that.isPlay = false;
            clearInterval(that.time);
        },
        resumeaudioEvent() {
            var that = this;
            that.playAudio()
            that.isPlay = !that.isPlay
        },
        playPauseAudioEvent(){
            var that = this;
            if(that.isPlay){
                if(that.isAudioPlayer){
                    that.audio.pause();
                }
                that.wavesurfer.pause()
                that.isPlay = false;
                clearInterval(that.time);
            }else{
                that.playAudio()
                that.isPlay = !that.isPlay
            }
        },
        getaudioEvent(val) {
            var that = this;
            this.config = val;
            that.filePathUrl = val.filePath;
            that.content = val.content;
            // 请求后台生成的音频波形
            fetch(val.wave_json)
                .then(function(res) { return res.json() })
                .then(function(res) {
                    var arr12 = [];
                    var num12 = res.data;
                    num12.forEach(function(val,index){
                        arr12.push(
                            Math.abs(val)
                        )
                    })

                    // 音频波形图使用绝对值
                    that.arr12 = arr12

                    that.arr12Save = arr12

                    // minimap波形图使用正负值
                    that.arr13 = res.data

                    that.arr13Save = res.data

                    that.setWavesurfer(val.filePath);

                    // 设置minimap的长度
                    setTimeout(function(){
                        var minimapWidth = document.querySelector('.bottom-mask').getBoundingClientRect().width;
                        that.minimapWidth = minimapWidth - 40 + 'px';
                    },1000)

                    // 初始化绘制minimap
                    setTimeout(function(){
                        that.draw();
                    },1000)

                    that.config.contentSave = that.config.content;
                    var voiceEditArticle = document.querySelector('#voiceEditArticle');
                    voiceEditArticle.insertAdjacentHTML('beforeend', '<div id="e2" style="position: absolute; top: -99999999px;"></div><div id="e3" style="position: absolute; top: -99999999px;"></div>');

                    that.init();
                })
        },
        maxSecEvent(val) {
            this.maxSec = val.maxSec
        },
        dblPlayEvent(e) {
            console.log(9888)
            var that = this;
            that.isPlay = false;
            that.twoClick = true;
            var bg = Number(e.bg)/1000;
            var ed = Number(e.ed)/1000;
            that.zmBg = bg;
            that.zmEd = ed;
            that.playdbl = e.playdbl;
            var index = e.index;
            if(that.zmRegion!=null){
                that.zmRegion.remove();
            }
            that.zmRegion = that.wavesurfer.addRegion({
                id: 'zmRegion'+Math.random(),
                start: bg,
                end: ed,
                loop: false,
                drag: false,
                resize: false,
                color: "rgba(86, 188, 222, 0.3)"
            })
            var regionLength1 = $('#audioPlayer > wave > region').length;
            for(var i=0; i<regionLength1; i++){
                var id = $('#audioPlayer > wave > region:eq('+i+')').attr('data-id');
                if(id.indexOf('zmRegion')!=-1){
                    $('#audioPlayer > wave > region:eq('+i+')').addClass('zIndex');
                }
            }
            clearInterval(that.time);
            clearInterval(that.time1);
            clearInterval(that.time2);
            clearInterval(that.time3);
            that.time1 = setInterval(function(){
                that.currentTime();
                if(that.wavesurfer.getCurrentTime()>=ed){
                    that.wavesurfer.pause();
                    clearInterval(that.time);
                    clearInterval(that.time1);
                    clearInterval(that.time2);
                    clearInterval(that.time3);
                    that.isPlay = false;
                    that.zmRegion.remove();
                }
            })
            that.wavesurfer.play(bg,ed);
            that.isPlay=!that.isPlay;
            $('#zmContainer > div').removeClass('on');
            $('#zmContainer > div:eq('+index+')').addClass('on');
        },
        setClipDateEvent(val){
            console.log(val)
            var that = this;
            that.clipDate = val.clipDate
            setTimeout(function(){
                // console.log(that.wavesurfer)
                that.clipDate.forEach(function(el,key){
                    that.currentRegion = that.wavesurfer.addRegion({
                        id: el.delRegion,
                        start: el.startTime,
                        end: el.endTime,
                        loop: false,
                        drag: false,
                        resize: true,
                        color: "rgba(0, 0, 0, 0.4)"
                    });
                    var len = el.arr.length;
                    if(len == 1){
                        if(el.arr[0].fatherIndex==0&&el.arr[0].index==0){
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-bg',el.startTime*1000)
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-ed',el.endTime*1000)
                        }else if(el.arr[0].index==0){
                            var preFatherIndex = el.arr[0].fatherIndex-1;
                            var preIndex = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1;
                            $('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(1)').attr('data-ed',el.startTime*1000)
                        }else if(el.arr[0].index==$('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1){
                            var nextFatherIndex = el.arr[0].fatherIndex+1;
                            var preIndex = el.arr[0].index-1;
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                            $('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-ed',el.startTime*1000)
                        }else{
                            var pre = el.arr[0].index - 1;
                            var next = el.arr[0].index + 1;
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                        }
                    }else if(len > 1){
                        var elArrLength = el.arr.length-1;
                        var startLength = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length;
                        var num1 = 0;
                        var startType = false;
                        for(var i=0; i<startLength; i++){
                            if($('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                num1++
                            }
                        }
                        if(num1 == startLength){
                            startType = true;
                        }
                        var endLength = $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length;
                        var num2 = 0;
                        var endType = false;
                        for(var i=0; i<endLength; i++){
                            if($('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                num2++
                            }
                        }
                        if(num2 == endLength){
                            endType = true;
                        }
                        if(startType){
                            if(el.arr[0].fatherIndex==0){
                                $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',el.startTime*1000)
                            }else{
                                var preNode = el.arr[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                            }
                        }else{
                            if(el.arr[0].index == 0){
                                var preNode = el.arr[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                            }else{
                                var pre = el.arr[0].index - 1;
                                // console.log(pre)
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                            }
                        }
                        if(endType){
                            var nextNode = Number(el.arr[elArrLength].fatherIndex) + 1;
                            $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                        }else{
                            if(Number(el.arr[elArrLength].index) == $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length-1){
                                var nextP = Number(el.arr[elArrLength].fatherIndex)+1
                                $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                            }else{
                                var next = Number(el.arr[elArrLength].index) + 1;
                                $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                            }
                        }
                    }
                })
                that.wavesurfer.on('region-update-end',function(e){
                    var maxSec = Number(that.maxSec)/1000;
                    if(e.end > maxSec || e.end==undefined || e.end==null || e.end==''){
                        e.end=maxSec;
                    }
                    if(e.start < 0 || e.start==undefined || e.start==null || e.start==''){
                        e.start=0;
                    }
                    var left = e.start.toFixed(2);
                    var width = e.end.toFixed(2);
                    var id = e.id;
                    // console.log(left,width,id);
                    // console.log(that.clipDate)
                    if(e.id.indexOf('currentRegion')==-1){
                        return false;
                    }
                    that.clipDate.forEach(function(el,index){
                        if(el.delRegion==id){
                            el.startTime = left
                            el.endTime = width
                            var len = el.arr.length;
                            if(len == 1){
                                if(el.arr[0].fatherIndex==0&&el.arr[0].index==0){
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-bg',el.startTime*1000)
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-ed',el.endTime*1000)
                                }else if(el.arr[0].index==0){
                                    var preFatherIndex = el.arr[0].fatherIndex-1;
                                    var preIndex = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1;
                                    $('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(1)').attr('data-ed',el-startTime*1000)
                                }else if(el.arr[0].index==$('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1){
                                    var nextFatherIndex = el.arr[0].fatherIndex+1;
                                    var preIndex = el.arr[0].index-1;
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                                    $('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-ed',el.startTime*1000)
                                }else{
                                    var pre = el.arr[0].index - 1;
                                    var next = el.arr[0].index + 1;
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                                }
                            }else{
                                var elArrLength = el.arr.length-1;
                                var startLength = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length;
                                var num1 = 0;
                                var startType = false;
                                for(var i=0; i<startLength; i++){
                                    if($('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                        num1++
                                    }
                                }
                                if(num1 == startLength){
                                    startType = true;
                                }
                                var endLength = $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length;
                                var num2 = 0;
                                var endType = false;
                                for(var i=0; i<endLength; i++){
                                    if($('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                        num2++
                                    }
                                }
                                if(num2 == endLength){
                                    endType = true;
                                }
                                if(startType){
                                    console.log(1)
                                    if(el.arr[0].fatherIndex==0){
                                        $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',el.startTime*1000)
                                    }else{
                                        var preNode = el.arr[0].fatherIndex - 1;
                                        var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                        $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                                    }
                                }else{
                                    console.log(2)
                                    if(el.arr[0].index == 0){
                                        var preNode = el.arr[0].fatherIndex - 1;
                                        var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                        $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                                    }else{
                                        var pre = el.arr[0].index - 1;
                                        console.log(pre)
                                        $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                                    }
                                }
                                if(endType){
                                    console.log(3)
                                    var nextNode = Number(el.arr[elArrLength].fatherIndex) + 1;
                                    $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                                }else{
                                    console.log(4)
                                    if(Number(el.arr[elArrLength].index) == $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length-1){
                                        var nextP = Number(el.arr[elArrLength].fatherIndex)+1
                                        $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                                    }else{
                                        var next = Number(el.arr[elArrLength].index) + 1;
                                        $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                                    }
                                }
                            }
                        }
                    })
                })
            },1000)
        },
        setDelInfoEvent(e) {
            var that = this;
            var delArr = [];
            var delNum2 = [];
            var arr20 = '';
            var newArrLength = e.arr0.length-1;

            // 保存操作前clipData的开始与结束时间
            if(newArrLength==0){
                if(e.arr0[0].fatherIndex==0 && e.arr0[0].index==0){
                    e.saveBg = Number($('#article-container > span:eq(0) > span:eq(0)').attr('data-bg'))/1000;
                    e.saveEd = Number($('#article-container > span:eq(0) > span:eq(0)').attr('data-ed'))/1000;
                }else if(e.arr0[0].index==0){
                    var preFatherIndex = Number(e.arr0[0].fatherIndex)-1;
                    var preIndex = $('#article-container > span:eq('+preFatherIndex+') > span').length-1;
                    e.saveBg = Number($('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-ed'))/1000;
                    e.saveEd = Number($('#article-container > span:eq('+e.arr0[0].fatherIndex+') > span:eq(1)').attr('data-bg'))/1000;
                }else if(e.arr0[0].index==$('#article-container > span:eq('+e.arr0[0].fatherIndex+') > span').length-1){
                    var nextFatherIndex = Number(e.arr0[0].fatherIndex)+1;
                    var preIndex = e.arr0[0].index-1;
                    e.saveBg = Number($('#article-container > span:eq('+e.arr0[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-ed'))/1000;
                    e.saveEd = Number($('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-bg'))/1000;
                }else{
                    var pre = e.arr0[0].index - 1;
                    var next = e.arr0[0].index + 1;
                    e.saveBg = Number($('#article-container > span:eq('+e.arr0[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed'))/1000;
                    e.saveEd = Number($('#article-container > span:eq('+e.arr0[0].fatherIndex+') > span:eq('+pre+')').attr('data-bg'))/1000;
                }
            }else{
                var elArrLength = e.arr0.length-1;
                var startLength = $('#article-container > span:eq('+e.arr0[0].fatherIndex+') > span').length;
                var num1 = 0;
                var startType = false;
                for(var j=0; j<startLength; j++){
                    if($('#article-container > span:eq('+e.arr0[0].fatherIndex+') > span:eq('+j+')').hasClass('on')){
                        num1++
                    }
                }
                if(num1 == startLength){
                    startType = true;
                }
                var endLength = $('#article-container > span:eq('+e.arr0[elArrLength].fatherIndex+') > span').length;
                var num2 = 0;
                var endType = false;
                for(var j=0; j<endLength; j++){
                    if($('#article-container > span:eq('+e.arr0[elArrLength].fatherIndex+') > span:eq('+j+')').hasClass('on')){
                        num2++
                    }
                }
                if(num2 == endLength){
                    endType = true;
                }
                if(startType){
                    if(e.arr0[0].fatherIndex==0){
                        e.saveBg = Number($('#article-container > span:eq(0) > span:eq(0)').attr('data-bg'))/1000
                    }else{
                        var preNode = e.arr0[0].fatherIndex - 1;
                        var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                        e.saveBg = Number($('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed'))/1000
                    }
                }else{
                    if(e.arr0[0].index == 0){
                        var preNode = e.arr0[0].fatherIndex - 1;
                        var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                        e.saveBg = Number($('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed'))/1000
                    }else{
                        var pre = e.arr0[0].index - 1;
                        e.saveBg = Number($('#article-container > span:eq('+e.arr0[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed'))/1000
                    }
                }
                if(endType){
                    var nextNode = Number(e.arr0[elArrLength].fatherIndex) + 1;
                    e.saveEd = Number( $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg'))/1000
                }else{
                    if(Number(e.arr0[elArrLength].index) == $('#article-container > span:eq('+e.arr0[elArrLength].fatherIndex+') > span').length-1){
                        var nextP = Number(e.arr0[elArrLength].fatherIndex)+1
                        e.saveEd = Number($('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg'))/1000
                    }else{
                        var next = Number(e.arr0[elArrLength].index) + 1;
                        e.saveEd = Number($('#article-container > span:eq('+e.arr0[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg'))/1000
                    }
                }
            }

            that.clipDate.forEach(function(val,key){
                var regionLength = $('#audioPlayer > wave > region').length;
                if(val.type=='del'){
                    if(e.bg==val.startTime&&e.ed>=val.endTime){
                        delNum2.push(key);
                        for(var i=0; i<regionLength; i++){
                            if($('#audioPlayer > wave > region')[i].dataset.id==val.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                    }else if(e.bg<=val.startTime&&e.ed==val.endTime){
                        delNum2.push(key);
                        for(var i=0; i<regionLength; i++){
                            if($('#audioPlayer > wave > region')[i].dataset.id==val.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                    }else if(e.bg<=val.startTime&&e.ed>=val.endTime){
                        delNum2.push(key);
                        for(var i=0; i<regionLength; i++){
                            if($('#audioPlayer > wave > region')[i].dataset.id==val.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                    }else if(e.bg<=val.startTime&&e.ed<=val.endTime&&e.ed>=val.startTime){
                        delNum2.push(key);
                        for(var i=0; i<regionLength; i++){
                            if($('#audioPlayer > wave > region')[i].dataset.id==val.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                        e.ed = val.endTime;
                    }else if(e.bg>=val.startTime&&e.bg<=val.endTime&&e.ed>=val.endTime){
                        delNum2.push(key);
                        for(var i=0; i<regionLength; i++){
                            if($('#audioPlayer > wave > region')[i].dataset.id==val.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                        e.bg = val.startTime;
                    }else if(e.bg>=val.startTime&&e.ed<=val.endTime){
                        delNum2.push(key);
                        for(var i=0; i<regionLength; i++){
                            if($('#audioPlayer > wave > region')[i].dataset.id==val.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                        e.bg = val.startTime;
                        e.ed = val.endTime;
                    }
                }
            })

            // 合并重复删除region区域后创建新region区域
            var newSaveBg = [];
            var newSaveEd = [];
            for(var i=delNum2.length-1;i>=0;i--){
                var len = that.clipDate[delNum2[i]].arr.length;
                var maxNum = that.clipDate[delNum2[i]].arr.length - 1;
                if(that.clipDate[delNum2[i]].saveStartTime!=''&&that.clipDate[delNum2[i]].saveStartTime!=undefined&&that.clipDate[delNum2[i]].saveStartTime!=null&&that.clipDate[delNum2[i]].saveEndTime!=''&&that.clipDate[delNum2[i]].saveEndTime!=undefined&&that.clipDate[delNum2[i]].saveEndTime!=null){
                    if(len==1){
                        if(that.clipDate[delNum2[i]].arr[0].fatherIndex==0&&that.clipDate[delNum2[i]].arr[0].index==0){
                            $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span:eq(0)').attr('data-bg',that.clipDate[delNum2[i]].saveStartTime*1000)
                            $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span:eq(0)').attr('data-ed',that.clipDate[delNum2[i]].saveEndTime*1000)
                        }else if(that.clipDate[delNum2[i]].arr[0].index==0){
                            var preFatherIndex = that.clipDate[delNum2[i]].arr[0].fatherIndex - 1;
                            var preIndex = $('#article-container > span:eq('+preFatherIndex+') > span').length-1;
                            $('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-bg',that.clipDate[delNum2[i]].saveEndTime*1000)
                            $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span:eq(1)').attr('data-ed',that.clipDate[delNum2[i]].saveStartTime*1000)
                        }else if(that.clipDate[delNum2[i]].arr[0].index==$('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+')').length-1){
                            var nextFatherIndex = that.clipDate[delNum2[i]].arr[0].fatherIndex + 1;
                            var preIndex = that.clipDate[delNum2[i]].arr[0].index - 1;
                            $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-bg',that.clipDate[delNum2[i]].saveEndTime*1000)
                            $('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-ed',that.clipDate[delNum2[i]].saveStartTime*1000)
                        }else{
                            var pre = that.clipDate[delNum2[i]].arr[0].index - 1;
                            var next = that.clipDate[delNum2[i]].arr[0].index + 1;
                            $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',that.clipDate[delNum2[i]].saveStartTime*1000)
                            $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',that.clipDate[delNum2[i]].saveEndTime*1000)
                        }
                    }else{
                        var elArrLength = that.clipDate[delNum2[i]].arr.length-1;
                        var startLength = $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span').length;
                        var num1 = 0;
                        var startType = false;
                        for(var j=0; j<startLength; j++){
                            if($('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span:eq('+j+')').hasClass('on')){
                                num1++
                            }
                        }
                        if(num1 == startLength){
                            startType = true;
                        }
                        var endLength = $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[elArrLength].fatherIndex+') > span').length;
                        var num2 = 0;
                        var endType = false;
                        for(var j=0; j<endLength; j++){
                            if($('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[elArrLength].fatherIndex+') > span:eq('+j+')').hasClass('on')){
                                num2++
                            }
                        }
                        if(num2 == endLength){
                            endType = true;
                        }
                        if(startType){
                            if(that.clipDate[delNum2[i]].arr[0].fatherIndex==0){
                                $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',that.clipDate[delNum2[i]].saveStartTime*1000)
                                newSaveBg.push(that.clipDate[delNum2[i]].saveStartTime*1000)
                            }else{
                                var preNode = that.clipDate[delNum2[i]].arr[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',that.clipDate[delNum2[i]].saveStartTime*1000)
                                newSaveBg.push(that.clipDate[delNum2[i]].saveStartTime*1000)
                            }
                        }else{
                            if(that.clipDate[delNum2[i]].arr[0].index == 0){
                                var preNode = that.clipDate[delNum2[i]].arr[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',that.clipDate[delNum2[i]].saveStartTime*1000)
                                newSaveBg.push(that.clipDate[delNum2[i]].saveStartTime*1000)
                            }else{
                                var pre = that.clipDate[delNum2[i]].arr[0].index - 1;
                                $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',that.clipDate[delNum2[i]].saveStartTime*1000)
                                newSaveBg.push(that.clipDate[delNum2[i]].saveStartTime*1000)
                            }
                        }
                        if(endType){
                            var nextNode = Number(that.clipDate[delNum2[i]].arr[elArrLength].fatherIndex) + 1;
                            $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',that.clipDate[delNum2[i]].saveEndTime*1000)
                            newSaveEd.push(that.clipDate[delNum2[i]].saveEndTime*1000)
                        }else{
                            if(Number(that.clipDate[delNum2[i]].arr[elArrLength].index) == $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[elArrLength].fatherIndex+') > span').length-1){
                                var nextP = Number(that.clipDate[delNum2[i]].arr[elArrLength].fatherIndex)+1
                                $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',that.clipDate[delNum2[i]].saveEndTime*1000)
                                newSaveEd.push(that.clipDate[delNum2[i]].saveEndTime*1000)
                            }else{
                                var next = Number(that.clipDate[delNum2[i]].arr[elArrLength].index) + 1;
                                $('#article-container > span:eq('+that.clipDate[delNum2[i]].arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',that.clipDate[delNum2[i]].saveEndTime*1000)
                                newSaveEd.push(that.clipDate[delNum2[i]].saveEndTime*1000)
                            }
                        }
                    }
                }
                that.clipDate.splice(delNum2[i],1)
            }

            newSaveBg.sort(function(a,b){
                return a > b ? 1 : -1;
            })

            newSaveEd.sort(function(a,b){
                return a < b ? 1 : -1;
            })

            if(that.notDel){
                for(var i=delArr.length-1;i>=0;i--){
                    that.clipDate.splice(delArr[i],1)
                }
                that.wavesurfer.clearRegions();
                that.clipDate.forEach(function(val,index){
                    if(val.type == 'region'){
                        that.currentRegion = that.wavesurfer.addRegion({
                            id: 'currentRegion',
                            start: val.regionStart,
                            end: val.regionEnd,
                            loop: false,
                            drag: false,
                            resize: false,
                            color: "rgba(254, 255, 255, 0)"
                        });
                        that.addRegion = that.wavesurfer.addRegion({
                            id: 'addRegion'+Math.random(),
                            start: val.startTime,
                            end: val.endTime,
                            loop: false,
                            drag: false,
                            resize: false,
                            color: "rgba(140, 191, 217, 0.4)"
                        });
                    }else{
                        that.currentRegion = that.wavesurfer.addRegion({
                            id: 'currentRegion'+Math.random(),
                            start: val.startTime,
                            end: val.endTime,
                            loop: false,
                            drag: false,
                            resize: true,
                            color: "rgba(0, 0, 0, 0.4)"
                        });
                    }
                })
                return false
            }

            var delRegion = 'currentRegion'+Math.random()
            that.currentRegion = that.wavesurfer.addRegion({
                id: delRegion,
                start: e.bg,
                end: e.ed,
                loop: false,
                drag: false,
                resize: true,
                color: "rgba(0, 0, 0, 0.4)"
            });
            that.clipDate.push({
                type: e.type,
                startTime: e.bg,
                endTime: e.ed,
                saveStartTime: e.saveBg,
                saveEndTime: e.saveEd,
                delRegion: delRegion,
                arr: e.arr0
            })

            // region区域更新事件
            that.wavesurfer.on('region-update-end',function(e){
                var maxSec = Number(that.maxSec)/1000;
                if(e.end > maxSec || e.end==undefined || e.end==null || e.end==''){
                    e.end=maxSec;
                }
                if(e.start < 0 || e.start==undefined || e.start==null || e.start==''){
                    e.start=0;
                }
                var left = e.start;
                var width = e.end;
                var id = e.id;
                if(e.id.indexOf('currentRegion')==-1){
                    return false;
                }
                that.clipDate.forEach(function(el,index){
                    if(el.delRegion==id){
                        el.startTime = left
                        el.endTime = width
                        var len = el.arr.length;
                        if(len == 1){
                            if(el.arr[0].fatherIndex==0&&el.arr[0].index==0){
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-bg',el.startTime*1000)
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-ed',el.endTime*1000)
                            }else if(el.arr[0].index==0){
                                var preFatherIndex = el.arr[0].fatherIndex-1;
                                var preIndex = $('#article-container > span:eq('+preFatherIndex+') > span').length-1;
                                $('#article-contianer > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(1)').attr('data-ed',el.startTime*1000)
                            }else if(el.arr[0].index==$('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1){
                                var nextFatherIndex = el.arr[0].fatherIndex+1;
                                var preIndex = el.arr[0].index-1;
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                                $('#article-container > span:eq('+nextFatherIndex+') > span:eq(1)').attr('data-ed',el.startTime*1000)
                            }else{
                                var pre = el.arr[0].index - 1;
                                var next = el.arr[0].index + 1;
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                            }
                        }else{
                            var elArrLength = el.arr.length-1;
                            var startLength = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length;
                            var num1 = 0;
                            var startType = false;
                            for(var i=0; i<startLength; i++){
                                if($('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                    num1++
                                }
                            }
                            if(num1 == startLength){
                                startType = true;
                            }
                            var endLength = $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length;
                            var num2 = 0;
                            var endType = false;
                            for(var i=0; i<endLength; i++){
                                if($('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                    num2++
                                }
                            }
                            if(num2 == endLength){
                                endType = true;
                            }
                            if(startType){
                                if(el.arr[0].fatherIndex==0){
                                    $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',el.startTime*1000)
                                }else{
                                    var preNode = el.arr[0].fatherIndex - 1;
                                    var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                    $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                                }
                            }else{
                                if(el.arr[0].index == 0){
                                    var preNode = el.arr[0].fatherIndex - 1;
                                    var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                    $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                                }else{
                                    var pre = el.arr[0].index - 1;
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                                }
                            }
                            if(endType){
                                var nextNode = Number(el.arr[elArrLength].fatherIndex) + 1;
                                $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                            }else{
                                if(Number(el.arr[elArrLength].index) == $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length-1){
                                    var nextP = Number(el.arr[elArrLength].fatherIndex)+1
                                    $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                                }else{
                                    var next = Number(el.arr[elArrLength].index) + 1;
                                    $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                                }
                            }
                        }
                    }
                })
            })
        },
        setCopyInfoEvent(e) {
            var that = this;
            that.addRegion = that.wavesurfer.addRegion({
                id: 'addRegion'+Math.random(),
                start: e.startTime,
                end: e.endTime,
                loop: false,
                drag: false,
                resize: false,
                color: "rgba(140, 191, 217, 0.4)"
            });
            var totalDurationSave = that.totalDurationSave;
            e.copyArrSave.forEach(function(el){
                totalDurationSave = totalDurationSave + Number(el.addTime/1000);
            })
            that.totalDurationSave = totalDurationSave;
            if(that.copyRegionArr.length > 0){
                var saveStartTime = e.startTime;
                var saveEndTime = e.endTime;
                var startTime = e.startTime;
                var endTime = e.endTime;
                that.copyRegionArr.forEach(function(el){
                    if(e.startTime>el.saveStart){
                        var addTime = Number(el.saveEnd) - Number(el.saveStart)
                        startTime = startTime+addTime;
                        endTime = endTime+addTime;
                    }else{
                        that.clipDate.forEach(function(val){
                            if(val.delRegion==el.random){
                                var addTime = Number(e.endTime) - Number(e.startTime)
                                val.startTime = val.startTime + addTime;
                                val.endTime = val.endTime + addTime;
                                el.saveStart = el.saveStart + addTime;
                                el.saveEnd = el.saveEnd + addTime;
                            }
                        })
                    }
                })
                var random = parseInt(Math.random()*8999+1000);
                e.startTime = startTime;
                e.endTime = endTime;
                that.copyRegionArr.push({
                    random: 'copyRegion'+random,
                    saveStart: saveStartTime,
                    saveEnd: saveEndTime
                })
                that.clipDate.push({
                    type: e.type,
                    delRegion: 'copyRegion'+random,
                    startTime: e.startTime,
                    endTime: e.endTime,
                    regionStart: e.regionStart,
                    regionEnd: e.regionEnd,
                    copyOnSaveArr: e.copyOnSaveArr
                })
            }else{
                var random = parseInt(Math.random()*8999+1000);
                that.copyRegionArr.push({
                    random: 'copyRegion'+random,
                    saveStart: e.startTime,
                    saveEnd: e.endTime
                })
                that.clipDate.push({
                    type: e.type,
                    delRegion: 'copyRegion'+random,
                    startTime: e.startTime,
                    endTime: e.endTime,
                    regionStart: e.regionStart,
                    regionEnd: e.regionEnd,
                    copyOnSaveArr: e.copyOnSaveArr
                })
            }
            //添加绝对值波形
            var totalDuration1Save = Number(that.totalDuration1);
            if(e.copyArrSave.length>1){
                for(var i=0; i<e.copyArrSave.length-1; i++){
                    totalDuration1Save = totalDuration1Save + (Number(e.copyArrSave[i].addTime)/1000)
                }
            }
            var saveStart = parseInt((Number(e.startTime)*Number(that.arr12.length))/Number(totalDuration1Save));
            var i = parseInt((Number(e.regionStart)*Number(that.arr12Save.length))/Number(that.totalDuration1));
            var ones = parseInt((Number(e.regionEnd)*Number(that.arr12Save.length))/Number(that.totalDuration1));
            var twos = [];
            for(i; i<ones; i++){
                twos.push(that.arr12Save[i])
            }
            twos.unshift(saveStart, 0);
            Array.prototype.splice.apply(that.arr12, twos);

            // 添加新波形
            var saveStart1 = parseInt((Number(e.startTime)*Number(that.arr13.length))/Number(totalDuration1Save));
            var i1 = parseInt((Number(e.regionStart)*Number(that.arr13Save.length))/Number(that.totalDuration1));
            var ones1 = parseInt((Number(e.regionEnd)*Number(that.arr13Save.length))/Number(that.totalDuration1));
            var twos1 = [];
            for(i1; i1<ones1; i1++){
                twos1.push(that.arr13Save[i1])
            }
            twos1.unshift(saveStart1, 0);
            Array.prototype.splice.apply(that.arr13, twos1);
            that.wavesurfer.destroy();
            that.wavesurfer = null;
            that.wavesurfer = WaveSurfer.create({
                container: '#audioPlayer',
                waveColor: '#39CFB1',
                progressColor: '#539084',
                backend: 'MediaElement',
                minPxPerSec: 100,
                height: 130,
                scrollParent: true,
                hideScrollbar: false,
                plugins: [
                    WaveSurfer.regions.create({

                    }),
                    WaveSurfer.timeline.create({
                        container: '#audioTimeLine'
                    }),
                ]
            })
            
            that.setWavesurfer(that.filePathUrl,that.totalDurationSave);
            // 设置minimap的长度
            setTimeout(function(){
                var minimapWidth = $('.bottom-mask').width();
                that.minimapWidth = minimapWidth - 40 + 'px';
            },1000)
            
            // 初始化绘制minimap
            setTimeout(function(){
                that.draw();
            },1000)

            setTimeout(function(){
                var width = Number(that.totalDurationSave)*100;
                that.clipDate.forEach(function(el,key){
                    if(el.type=='del'){
                        that.currentRegion = that.wavesurfer.addRegion({
                            id: el.delRegion,
                            start: el.startTime,
                            end: el.endTime,
                            loop: false,
                            drag: false,
                            resize: true,
                            color: "rgba(0, 0, 0, 0.4)"
                        });
                    }else{
                        that.currentRegion = that.wavesurfer.addRegion({
                            id: el.delRegion,
                            start: el.startTime,
                            end: el.endTime,
                            loop: false,
                            drag: false,
                            resize: true,
                            color: "rgba(140, 191, 217, 0.4)"
                        });
                        var totalDurationSave = that.wavesurfer.getDuration();
                        e.copyArrSave.forEach(function(el){
                            totalDurationSave = totalDurationSave + Number(el.addTime/1000);
                        })
                        var left = (Number(el.startTime)*width)/Number(totalDurationSave);
                        $('.wavesurfer-region[data-id='+el.delRegion+']').css('left',left+'px');
                        var minWidth = ((Number(el.endTime)-Number(el.startTime))*Number(width))/Number(totalDurationSave);
                        $('.wavesurfer-region[data-id='+el.delRegion+']').css('width',minWidth+'px');
                    }
                    var len = 0;
                    if(el.arr!=null&&el.arr!=undefined&&el.arr!=''){
                        len = el.arr.length;
                    }
                    if(len == 1){
                        if(el.arr[0].fatherIndex==0&&el.arr[0].index==0){
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-bg',el.startTime*1000)
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-ed',el.endTime*1000)
                        }else if(el.arr[0].index==0){
                            var preFatherIndex = el.arr[0].fatherIndex-1;
                            var preIndex = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1;
                            $('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(1)').attr('data-ed',el.startTime*1000)
                        }else if(el.arr[0].index==$('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1){
                            var nextFatherIndex = el.arr[0].fatherIndex+1;
                            var preIndex = el.arr[0].index-1;
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                            $('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-ed',el.startTime*1000)
                        }else{
                            var pre = el.arr[0].index - 1;
                            var next = el.arr[0].index + 1;
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                            $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                        }
                    }else if(len > 1){
                        var elArrLength = el.arr.length-1;
                        var startLength = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length;
                        var num1 = 0;
                        var startType = false;
                        for(var i=0; i<startLength; i++){
                            if($('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                num1++
                            }
                        }
                        if(num1 == startLength){
                            startType = true;
                        }
                        var endLength = $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length;
                        var num2 = 0;
                        var endType = false;
                        for(var i=0; i<endLength; i++){
                            if($('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                num2++
                            }
                        }
                        if(num2 == endLength){
                            endType = true;
                        }
                        if(startType){
                            if(el.arr[0].fatherIndex==0){
                                $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',el.startTime*1000)
                            }else{
                                var preNode = el.arr[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                            }
                        }else{
                            if(el.arr[0].index == 0){
                                var preNode = el.arr[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                            }else{
                                var pre = el.arr[0].index - 1;
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                            }
                        }
                        if(endType){
                            var nextNode = Number(el.arr[elArrLength].fatherIndex) + 1;
                            $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                        }else{
                            if(Number(el.arr[elArrLength].index) == $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length-1){
                                var nextP = Number(el.arr[elArrLength].fatherIndex)+1
                                $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                            }else{
                                var next = Number(el.arr[elArrLength].index) + 1;
                                $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                            }
                        }
                    }
                })
                that.wavesurfer.on('region-update-end',function(e){
                    var maxSec = Number(that.maxSec)/1000;
                    if(e.end > maxSec || e.end==undefined || e.end==null || e.end==''){
                        e.end=maxSec;
                    }
                    if(e.start < 0 || e.start==undefined || e.start==null || e.start==''){
                        e.start=0;
                    }
                    var left = e.start.toFixed(2);
                    var width = e.end.toFixed(2);
                    var id = e.id;
                    if(e.id.indexOf('currentRegion')==-1){
                        return false;
                    }
                    that.clipDate.forEach(function(el,index){
                        if(el.delRegion==id){
                            el.startTime = left
                            el.endTime = width
                            var len = el.arr.length;
                            if(len == 1){
                                if(el.arr[0].fatherIndex==0&&el.arr[0].index==0){
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-bg',el.startTime*1000)
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-ed',el.endTime*1000)
                                }else if(el.arr[0].index==0){
                                    var preFatherIndex = el.arr[0].fatherIndex-1;
                                    var preIndex = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1;
                                    $('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(1)').attr('data-ed',el-startTime*1000)
                                }else if(el.arr[0].index==$('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1){
                                    var nextFatherIndex = el.arr[0].fatherIndex+1;
                                    var preIndex = el.arr[0].index-1;
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                                    $('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-ed',el.startTime*1000)
                                }else{
                                    var pre = el.arr[0].index - 1;
                                    var next = el.arr[0].index + 1;
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                                }
                            }else{
                                var elArrLength = el.arr.length-1;
                                var startLength = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length;
                                var num1 = 0;
                                var startType = false;
                                for(var i=0; i<startLength; i++){
                                    if($('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                        num1++
                                    }
                                }
                                if(num1 == startLength){
                                    startType = true;
                                }
                                var endLength = $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length;
                                var num2 = 0;
                                var endType = false;
                                for(var i=0; i<endLength; i++){
                                    if($('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                        num2++
                                    }
                                }
                                if(num2 == endLength){
                                    endType = true;
                                }
                                if(startType){
                                    if(el.arr[0].fatherIndex==0){
                                        $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',el.startTime*1000)
                                    }else{
                                        var preNode = el.arr[0].fatherIndex - 1;
                                        var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                        $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                                    }
                                }else{
                                    if(el.arr[0].index == 0){
                                        var preNode = el.arr[0].fatherIndex - 1;
                                        var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                        $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                                    }else{
                                        var pre = el.arr[0].index - 1;
                                        $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                                    }
                                }
                                if(endType){
                                    var nextNode = Number(el.arr[elArrLength].fatherIndex) + 1;
                                    $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                                }else{
                                    if(Number(el.arr[elArrLength].index) == $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length-1){
                                        var nextP = Number(el.arr[elArrLength].fatherIndex)+1
                                        $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                                    }else{
                                        var next = Number(el.arr[elArrLength].index) + 1;
                                        $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                                    }
                                }
                            }
                        }
                    })
                })
            },1000)
        },
        submitContentEvent(e) {
            console.log(e)
            var that = this;
            $('#audioWord').html('')
            var arrResult = [];
            that.zmContent = e.content;
            that.zmContent.forEach(function(val,index){
                var left = Number(val.bg)/10 + 'px';
                var width = Number(val.ed)/10-Number(val.bg)/10 + 'px';
                arrResult.push(
                    '<div data-index='+index+' data-bg='+Number(val.bg)/10+' data-ed='+Number(val.ed)/10+' style="display:inline-block; text-align: center; position:absolute; left: '+left+'; width: '+width+'; height: 24px; line-height: 24px; background: rgba(0,0,0,0.1); border-radius:4px; box-sizing: border-box;">'+val.onebest+'</div>'
                )
            })
            that.arrResult = arrResult;
            arrResult = arrResult.join('');
            var arrContainer = '<div id="zmContainer" style="left:20px">'+arrResult+'</div>';
            $('#audioWord').append(arrContainer);

            // 字幕点击跳转事件
            $('#zmContainer > div').click(function(){

                that.isPlay = false;
                that.playdbl = true;
                that.oneClick = true;
                $('#zmContainer > div').removeClass('on');
                $(this).addClass('on');
                var bg = $(this).attr('data-bg');
                var ed = $(this).attr('data-ed');

                bg = Number(bg)/100;
                ed = Number(ed)/100;
                that.zmBg = bg;
                that.zmEd = ed;
                if(that.zmRegion!=null){
                    that.zmRegion.remove();
                }
                that.zmRegion = that.wavesurfer.addRegion({
                    id: 'zmRegion'+Math.random(),
                    start: bg,
                    end: ed,
                    loop: false,
                    drag: false,
                    resize: false,
                    color: "rgba(86, 188, 222, 0.3)"
                })

                var regionLength1 = $('#audioPlayer > wave > region').length;
                for(var i=0; i<regionLength1; i++){
                    var id = $('#audioPlayer > wave > region:eq('+i+')').attr('data-id');
                    if(id.indexOf('zmRegion')!=-1){
                        $('#audioPlayer > wave > region:eq('+i+')').addClass('zIndex');
                    }
                }

                clearInterval(that.time);
                clearInterval(that.time1);
                clearInterval(that.time2);
                clearInterval(that.time3);
                that.time1 = setInterval(function(){
                    that.currentTime();
                    if(that.wavesurfer.getCurrentTime()>=ed){
                        that.wavesurfer.pause();
                        clearInterval(that.time);
                        clearInterval(that.time1);
                        clearInterval(that.time2);
                        clearInterval(that.time3);
                        that.isPlay = false;
                        that.zmRegion.remove();
                    }
                })
                that.wavesurfer.play(bg,ed);

                that.isPlay=!that.isPlay;

            })
        },
        resumeDelEvent(e) {
            var that = this;
            var bg = Number(e.bg)/1000;
            var ed = Number(e.ed)/1000;
            var arrLength = e.arr.length;
            var delNum = '';
            var delNum1 = [];
            that.clipDate = e.clipDate;
            // console.log(that.clipDate)
            if(arrLength==1){
                var newArr = [];
                // 设置恢复时间段
                that.clipDate.forEach(function(el,index1){
                    if(el.type == 'del'){
                        if(bg >= el.startTime && ed <= el.endTime) {
                            var len1 = el.arr.length-1;
                            var minFatherIndex = el.arr[0].fatherIndex;
                            var minIndex = el.arr[0].index;
                            var maxFatherIndex = el.arr[len1].fatherIndex;
                            var maxIndex = el.arr[len1].index;
                            delNum = index1;
                            if(e.arr[0].index==minIndex&&e.arr[0].fatherIndex==minFatherIndex&&e.arr[0].index==maxIndex&&e.arr[0].fatherIndex==maxFatherIndex){
                                // console.log(333)
                                return;
                            }else if(e.arr[0].index==0&&e.arr[0].fatherIndex==minFatherIndex){
                                // console.log(333)
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex+1,
                                    toFatherIndex: Number(e.arr[0].fatherIndex),
                                    toIndex: maxIndex
                                })
                            }else if(e.arr[0].index==0&&e.arr[0].fatherIndex==maxFatherIndex){
                                // console.log(333)
                                var preNode = Number(e.arr[0].fatherIndex)-1;
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: Number(e.arr[0].fatherIndex)-1,
                                    toIndex: $('#article-container > span:eq('+preNode+') > span').length - 1
                                })
                            }else if(e.arr[0].index==0&&e.arr[0].fatherIndex<maxFatherIndex){
                                // console.log(333)
                                var preNode = Number(e.arr[0].fatherIndex)-1;
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: Number(e.arr[0].fatherIndex)-1,
                                    toIndex: $('#article-container > span:eq('+preNode+') > span').length - 1
                                })
                                newArr.push({
                                    fromFatherIndex: Number(e.arr[0].fatherIndex),
                                    fromIndex: 1,
                                    toFatherIndex: maxFatherIndex,
                                    toIndex: maxIndex
                                })
                            }else if(e.arr[0].index==maxIndex&&e.arr[0].fatherIndex==maxFatherIndex){
                                // console.log(5)
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: maxFatherIndex,
                                    toIndex: Number(maxIndex)-1
                                })
                            }else if(e.arr[0].index==$('#article-container > span:eq('+Number(e.arr[0].fatherIndex)+') > span').length - 1&&e.arr[0].fatherIndex<maxFatherIndex){
                                // console.log(333)
                                if(e.arr[0].index==0){
                                    var pre = Number(e.arr[0].fatherIndex)-1;
                                    newArr.push({
                                        fromFatherIndex: minFatherIndex,
                                        fromIndex: minIndex,
                                        toFatherIndex: Number(e.arr[0].fatherIndex)-1,
                                        toIndex: $('#article-container > span:eq('+pre+') > span').length - 1
                                    })
                                }else{
                                    newArr.push({
                                        fromFatherIndex: minFatherIndex,
                                        fromIndex: minIndex,
                                        toFatherIndex: Number(e.arr[0].fatherIndex),
                                        toIndex: e.arr[0].index - 1
                                    })
                                }
                                newArr.push({
                                    fromFatherIndex: Number(e.arr[0].fatherIndex)+1,
                                    fromIndex: 0,
                                    toFatherIndex: maxFatherIndex,
                                    toIndex: maxIndex
                                })
                            }else{
                                // console.log(333)
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: e.arr[0].fatherIndex,
                                    toIndex: Number(e.arr[0].index)-1
                                })
                                newArr.push({
                                    fromFatherIndex: Number(e.arr[0].fatherIndex),
                                    fromIndex: Number(e.arr[0].index)+1,
                                    toFatherIndex: maxFatherIndex,
                                    toIndex: maxIndex
                                })
                            }
                        }
                    }
                })
                that.clipDate.forEach(function(e,key){
                    // console.log(e,key)
                    if(key==delNum){
                        // console.log(e)
                        var regionLength = $('#audioPlayer > wave > region').length;
                        for(var i=0; i<regionLength; i++){
                            // console.log($('#audioPlayer > wave > region:eq('+i+')'))
                            if($('#audioPlayer > wave > region')[i].dataset.id==e.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                    }
                })

                var resumeArrLength = that.clipDate[delNum].arr.length;
                if(resumeArrLength == 1){
                    if(that.clipDate[delNum].arr[0].fatherIndex==0&&that.clipDate[delNum].arr[0].index==0){
                        $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',that.clipDate[delNum].saveStartTime*1000);
                        $('#article-container > span:eq(0) > span:eq(0)').attr('data-ed',that.clipDate[delNum].saveEndTime*1000);
                    }else if(that.clipDate[delNum].arr[0].index==0){
                        var preFatherIndex = Number(that.clipDate[delNum].arr[0].fatherIndex)-1;
                        var preIndex = $('#article-container > span:eq('+preFatherIndex+') > span').length-1;
                        // var nextFatherIndex = Number(that.clipDate[delNum].arr[0])
                        $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq(1)').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                        $('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                    }else if(that.clipDate[delNum].arr[0].index==$('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span').length-1){
                        var nextFatherIndex = Number(that.clipDate[delNum].arr[0].fatherIndex)+1;
                        var preIndex = that.clipDate[delNum].arr[0].index-1;
                        $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                        $('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                    }else{
                        var pre = that.clipDate[delNum].arr[0].index - 1;
                        var next = that.clipDate[delNum].arr[0].index + 1;
                        $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                        $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                    }
                }else{
                    var elArrLength = that.clipDate[delNum].arr.length-1;
                    var startLength = $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span').length;
                    var num1 = 0;
                    var startType = false;
                    for(var i=0; i<startLength; i++){
                        if($('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                            num1++
                        }
                    }
                    if(num1 == startLength){
                        startType = true;
                    }
                    var endLength = $('#article-container > span:eq('+that.clipDate[delNum].arr[elArrLength].fatherIndex+') > span').length;
                    var num2 = 0;
                    var endType = false;
                    for(var i=0; i<endLength; i++){
                        if($('#article-container > span:eq('+that.clipDate[delNum].arr[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                            num2++
                        }
                    }
                    if(num2 == endLength){
                        endType = true;
                    }
                    if(startType){
                        // console.log(1)
                        if(that.clipDate[delNum].arr[0].fatherIndex==0){
                            $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',that.clipDate[delNum].saveStartTime*1000)
                        }else{
                            var preNode = that.clipDate[delNum].arr[0].fatherIndex - 1;
                            var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                            $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                        }
                    }else{
                        // console.log(2)
                        if(that.clipDate[delNum].arr[0].index == 0){
                            var preNode = that.clipDate[delNum].arr[0].fatherIndex - 1;
                            var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                            $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                        }else{
                            var pre = that.clipDate[delNum].arr[0].index - 1;
                            // console.log(pre)
                            $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                        }
                    }
                    if(endType){
                        // console.log(3)
                        var nextNode = Number(that.clipDate[delNum].arr[elArrLength].fatherIndex) + 1;
                        $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                    }else{
                        // console.log(4)
                        if(Number(that.clipDate[delNum].arr[elArrLength].index) == $('#article-container > span:eq('+that.clipDate[delNum].arr[elArrLength].fatherIndex+') > span').length-1){
                            var nextP = Number(that.clipDate[delNum].arr[elArrLength].fatherIndex)+1
                            $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                        }else{
                            var next = Number(that.clipDate[delNum].arr[elArrLength].index) + 1;
                            $('#article-container > span:eq('+that.clipDate[delNum].arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                        }
                    }
                }

                that.clipDate.splice(delNum,1)


                newArr.forEach(function(el){
                    var arr0 = [];
                    // console.log(el)
                    var bg = $('#article-container > span:eq('+el.fromFatherIndex+') > span:eq('+el.fromIndex+')').attr('data-bg');
                    var ed = $('#article-container > span:eq('+el.toFatherIndex+') > span:eq('+el.toIndex+')').attr('data-ed');
                    arr0.push({
                        fatherIndex: el.fromFatherIndex,
                        index: el.fromIndex
                    })
                    arr0.push({
                        fatherIndex: el.toFatherIndex,
                        index: el.toIndex
                    })

                    var saveBg = 0;
                    var saveEd = 0;
                    var saveNewArrLength = arr0.length;
                    if(saveNewArrLength == 1){
                        if(arr0[0].fatherIndex==0&&arr0[0].index==0){
                            saveBg = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq(0)').attr('data-bg'))/1000;
                            saveEd = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq(0)').attr('data-ed'))/1000;
                        }else if(arr0[0].index==0){
                            var preFatherIndex = Number(arr0[0].fatherIndex)-1;
                            var nextFatherIndex = Number(arr0[0].fatherIndex)+1;
                            var preIndex = $('#article-container > span:eq('+preFatherIndex+') > span').length - 1;
                            saveBg = Number($('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-ed'))/1000;
                            saveEd = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq(1)').attr('data-bg'))/1000;
                        }else if(arr0[0].index==$('#article-container > span:eq('+preFatherIndex+') > span').length - 1){
                            var nextFatherIndex = Number(arr0[0].fatherIndex)+1;
                            var preIndex = arr0[0].index - 1;
                            saveBg = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-ed'))/1000;
                            saveEd = Number($('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-bg'))/1000;
                        }else{
                            var pre = arr0[0].index - 1;
                            var next = arr0[0].index + 1;
                            saveBg = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed'))/1000;
                            saveEd = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+next+')').attr('data-bg'))/1000;
                        }
                    }else{
                        var elArrLength = arr0.length-1;
                        var startLength = $('#article-container > span:eq('+arr0[0].fatherIndex+') > span').length;
                        var num1 = 0;
                        var startType = false;
                        for(var i=0; i<startLength; i++){
                            if($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                num1++
                            }
                        }
                        if(num1 == startLength){
                            startType = true;
                        }
                        var endLength = $('#article-container > span:eq('+arr0[elArrLength].fatherIndex+') > span').length;
                        var num2 = 0;
                        var endType = false;
                        for(var i=0; i<endLength; i++){
                            if($('#article-container > span:eq('+arr0[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                num2++
                            }
                        }
                        if(num2 == endLength){
                            endType = true;
                        }
                        if(startType){
                            // console.log(1)
                            if(arr0[0].fatherIndex==0){
                                saveBg = Number($('#article-container > span:eq(0) > span:eq(0)').attr('data-bg'))/1000;
                            }else{
                                var preNode = arr0[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                saveBg = Number($('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed'))/1000
                            }
                        }else{
                            // console.log(2)
                            if(arr0[0].index == 0){
                                var preNode = arr0[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                                saveBg = Number($('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed'))/1000
                            }else{
                                var pre = arr0[0].index - 1;
                                // console.log(pre)
                                saveBg = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed'))/1000
                            }
                        }
                        if(endType){
                            // console.log(3)
                            var nextNode = Number(arr0[elArrLength].fatherIndex) + 1;
                            saveEd = Number($('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg'))/1000
                        }else{
                            // console.log(4)
                            if(Number(arr0[elArrLength].index) == $('#article-container > span:eq('+arr0[elArrLength].fatherIndex+') > span').length-1){
                                var nextP = Number(arr0[elArrLength].fatherIndex)+1
                                saveEd = Number($('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg'))/1000
                            }else{
                                var next = Number(arr0[elArrLength].index) + 1;
                                saveEd = Number($('#article-container > span:eq('+arr0[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg'))/1000
                            }
                        }
                    }

                    var delRegion = 'currentRegion'+Math.random()
                    that.currentRegion = that.wavesurfer.addRegion({
                        id: delRegion ,
                        start: Number(bg)/1000,
                        end: Number(ed)/1000,
                        loop: false,
                        drag: false,
                        resize: true,
                        color: "rgba(0, 0, 0, 0.4)"
                    });
                    that.clipDate.push({
                        type: 'del',
                        delRegion: delRegion,
                        startTime: Number(bg)/1000,
                        endTime: Number(ed)/1000,
                        saveStartTime: saveBg,
                        saveEndTime: saveEd,
                        arr: arr0
                    })
                })

                // console.log(that.clipDate);
            }else{
                // console.log(that.clipDate);
                // console.log(bg,ed)
                // return false;
                var newArr = [];
                // var index = el.arr[0].index;
                that.clipDate.forEach(function(el,index1){
                    // console.log(el)
                    if(el.type == 'del'){
                        if(bg >= el.startTime && ed <= el.endTime) {
                        // if(el.startTime >= bg && el.endTime <= ed) {
                            // console.log(index1)
                            var len1 = el.arr.length-1;
                            var len2 = e.arr.length-1;
                            var minFatherIndex = el.arr[0].fatherIndex;
                            var minIndex = el.arr[0].index;
                            var maxFatherIndex = el.arr[len1].fatherIndex;
                            var maxIndex = el.arr[len1].index;
                            delNum = index1;
                            // delNum1.push(index1)
                            if(e.arr[0].index==minIndex&&e.arr[0].fatherIndex==minFatherIndex&&e.arr[len2].index==maxIndex&&e.arr[len2].fatherIndex==maxFatherIndex){
                                return
                            }else if(e.arr[len2].index==maxIndex&&e.arr[len2].fatherIndex==maxFatherIndex&&e.arr[0].index>0&&e.arr[0].fatherIndex<=maxFatherIndex){
                                // console.log(444)
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: Number(e.arr[0].fatherIndex),
                                    toIndex: Number(e.arr[0].index)-1
                                })
                            }else if(e.arr[len2].index==maxIndex&&e.arr[len2].fatherIndex==maxFatherIndex&&e.arr[0].index==0&&e.arr[0].fatherIndex==maxFatherIndex){
                                // console.log(444)
                                var preNode = Number(e.arr[0].fatherIndex)-1;
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: Number(e.arr[0].fatherIndex)-1,
                                    toIndex: $('#article-container > span:eq('+preNode+') > span').length - 1
                                })
                            }else if(e.arr[len2].index==maxIndex&&e.arr[len2].fatherIndex==maxFatherIndex&&e.arr[0].index==0&&e.arr[0].fatherIndex<=maxFatherIndex){
                                // console.log(444)
                                var preNode = Number(e.arr[0].fatherIndex)-1;
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: Number(e.arr[0].fatherIndex)-1,
                                    toIndex: $('#article-container > span:eq('+preNode+') > span').length - 1
                                })
                            }else if(e.arr[0].index==minIndex&&e.arr[0].fatherIndex==minFatherIndex&&e.arr[len2].index<$('#article-container > span:eq('+Number(e.arr[0].fatherIndex)+') > span').length - 1&&e.arr[len2].fatherIndex<=maxFatherIndex){
                                // console.log(444)
                                newArr.push({
                                    fromFatherIndex: e.arr[len2].fatherIndex,
                                    fromIndex: Number(e.arr[len2].index) + 1,
                                    toFatherIndex: maxFatherIndex,
                                    toIndex: maxIndex
                                })
                            }else if(e.arr[0].index==minIndex&&e.arr[0].fatherIndex==minFatherIndex&&e.arr[len2].index==$('#article-container > span:eq('+Number(e.arr[0].fatherIndex)+') > span').length - 1&&e.arr[len2].fatherIndex<=maxFatherIndex){
                                // console.log(444)
                                newArr.push({
                                    fromFatherIndex: Number(e.arr[len2].fatherIndex) + 1,
                                    fromIndex: 0,
                                    toFatherIndex: maxFatherIndex,
                                    toIndex: maxIndex
                                })
                            }else if(e.arr[0].index==0&&e.arr[0].fatherIndex==minFatherIndex){
                                // console.log(444)
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex+1,
                                    toFatherIndex: Number(e.arr[0].fatherIndex),
                                    toIndex: maxIndex
                                })
                            }else if(e.arr[0].index==0&&e.arr[0].fatherIndex==maxFatherIndex){
                                // console.log(222)
                                var preNode = Number(e.arr[0].fatherIndex)-1
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: Number(e.arr[0].fatherIndex)-1,
                                    toIndex: $('#article-container > span:eq('+preNode+') > span').length - 1
                                })
                            }else if(e.arr[0].index==maxIndex&&e.arr[0].fatherIndex==maxFatherIndex){
                                // console.log(5)
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: maxFatherIndex,
                                    toIndex: Number(maxIndex)-1
                                })
                            }else if(e.arr[0].index==$('#article-container > span:eq('+Number(e.arr[0].fatherIndex)+') > span').length - 1&&e.arr[0].fatherIndex<maxFatherIndex){
                                // console.log(444)
                                newArr.push({
                                    fromFatherIndex: minFatherIndex,
                                    fromIndex: minIndex,
                                    toFatherIndex: Number(e.arr[0].fatherIndex)-1,
                                    toIndex: e.arr[0].index - 1
                                })
                                newArr.push({
                                    fromFatherIndex: Number(maxIndex),
                                    fromIndex: 0,
                                    toFatherIndex: maxFatherIndex,
                                    toIndex: maxIndex
                                })
                            }else{
                                // console.log(555)
                                if(Number(e.arr[0].index)==0){
                                    var preFatherIndex = Number(e.arr[0].fatherIndex)-1;
                                    var preIndex = $('#article-container > span:eq('+preFatherIndex+') > span').length - 1;
                                    newArr.push({
                                        fromFatherIndex: minFatherIndex,
                                        fromIndex: minIndex,
                                        toFatherIndex: preFatherIndex,
                                        toIndex: preIndex
                                    })
                                }else{
                                    newArr.push({
                                        fromFatherIndex: minFatherIndex,
                                        fromIndex: minIndex,
                                        toFatherIndex: e.arr[0].fatherIndex,
                                        toIndex: Number(e.arr[0].index)-1
                                    })
                                }
                                if(Number(e.arr[len2].index)==$('#article-container > span:eq('+Number(e.arr[len2].fatherIndex)+') > span').length - 1){
                                    newArr.push({
                                        fromFatherIndex: Number(e.arr[len2].fatherIndex)+1,
                                        fromIndex: 0,
                                        toFatherIndex: maxFatherIndex,
                                        toIndex: maxIndex
                                    })
                                }else{
                                    newArr.push({
                                        fromFatherIndex: Number(e.arr[len2].fatherIndex),
                                        fromIndex: Number(e.arr[len2].index)+1,
                                        toFatherIndex: maxFatherIndex,
                                        toIndex: maxIndex
                                    })
                                }
                            }
                        }
                    }
                })

                // console.log(delNum)

                // return false

                that.clipDate.forEach(function(e,key){

                    if(key==delNum){
                        var regionLength = $('#audioPlayer > wave > region').length;
                        for(var i=0; i<regionLength; i++){
                            if($('#audioPlayer > wave > region')[i].dataset.id==e.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                    }
                })
                // console.log(delNum)
                // console.log(that.clipDate[delNum])
                // return false;
                // if(delNum==''){
                //     // return false;
                // }else{

                var resumeArrLength = that.clipDate[delNum].arr.length;
                // console.log(resumeArrLength)
                // return false
                if(resumeArrLength == 1){
                    var pre = that.clipDate[delNum].arr[0].index - 1;
                    var next = that.clipDate[delNum].arr[0].index + 1;
                    $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                    $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                }else{
                    var elArrLength = that.clipDate[delNum].arr.length-1;
                    var startLength = $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span').length;
                    var num1 = 0;
                    var startType = false;
                    for(var i=0; i<startLength; i++){
                        if($('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                            num1++
                        }
                    }
                    if(num1 == startLength){
                        startType = true;
                    }
                    var endLength = $('#article-container > span:eq('+that.clipDate[delNum].arr[elArrLength].fatherIndex+') > span').length;
                    var num2 = 0;
                    var endType = false;
                    for(var i=0; i<endLength; i++){
                        if($('#article-container > span:eq('+that.clipDate[delNum].arr[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                            num2++
                        }
                    }
                    if(num2 == endLength){
                        endType = true;
                    }
                    if(startType){
                        // console.log(1)
                        if(that.clipDate[delNum].arr[0].fatherIndex==0){
                            $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',that.clipDate[delNum].saveStartTime*1000)
                        }else{
                            var preNode = that.clipDate[delNum].arr[0].fatherIndex - 1;
                            var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                            $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                        }
                    }else{
                        // console.log(2)
                        if(that.clipDate[delNum].arr[0].index == 0){
                            var preNode = that.clipDate[delNum].arr[0].fatherIndex - 1;
                            var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                            $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                        }else{
                            var pre = that.clipDate[delNum].arr[0].index - 1;
                            // console.log(pre)
                            $('#article-container > span:eq('+that.clipDate[delNum].arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                        }
                    }
                    if(endType){
                        // console.log(3)
                        var nextNode = Number(that.clipDate[delNum].arr[elArrLength].fatherIndex) + 1;
                        $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                    }else{
                        // console.log(4)
                        if(Number(that.clipDate[delNum].arr[elArrLength].index) == $('#article-container > span:eq('+that.clipDate[delNum].arr[elArrLength].fatherIndex+') > span').length-1){
                            var nextP = Number(that.clipDate[delNum].arr[elArrLength].fatherIndex)+1
                            $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                        }else{
                            var next = Number(that.clipDate[delNum].arr[elArrLength].index) + 1;
                            $('#article-container > span:eq('+that.clipDate[delNum].arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',that.clipDate[delNum].saveEndTime*1000)
                        }
                    }
                }
                // return;

                that.clipDate.splice(delNum,1)

                // return false;
                // }

                newArr.forEach(function(el){
                    // console.log(el)
                    var arr0 = [];
                    var bg = $('#article-container > span:eq('+el.fromFatherIndex+') > span:eq('+el.fromIndex+')').attr('data-bg');
                    var ed = $('#article-container > span:eq('+el.toFatherIndex+') > span:eq('+el.toIndex+')').attr('data-ed');
                    arr0.push({
                        fatherIndex: el.fromFatherIndex,
                        index: el.fromIndex
                    })
                    arr0.push({
                        fatherIndex: el.toFatherIndex,
                        index: el.toIndex
                    })
                    var saveBg = 0;
                    var saveEd = 0;
                    var saveNewArrLength = arr0.length;
                    if(saveNewArrLength == 1){
                        if(arr0[0].fatherIndex==0&&arr0[0].index==0){
                            saveBg = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq(0)').attr('data-bg'))/1000;
                            saveEd = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq(0)').attr('data-ed'))/1000;
                        }else if(arr0[0].index==0){
                            var preFatherIndex = Number(arr0[0].fatherIndex)-1;
                            var nextFatherIndex = Number(arr0[0].fatherIndex)+1;
                            var preIndex = $('#article-container > span:eq('+preFatherIndex+') > span').length - 1;
                            saveBg = Number($('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-ed'))/1000;
                            saveEd = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq(1)').attr('data-bg'))/1000;
                        }else if(arr0[0].index==$('#article-container > span:eq('+arr0[0].fatherIndex+') > span').length-1){
                            var preIndex = Number(arr0[0].index)-1;
                            var nextFatherIndex = Number(arr0[0].fatherIndex)+1;
                            saveBg = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-ed'))/1000;
                            saveEd = Number($('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-bg'))/1000;
                        }else{
                            var pre = arr0[0].index - 1;
                            var next = arr0[0].index + 1;
                            saveBg = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed'))/1000;
                            saveEd = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+next+')').attr('data-bg'))/1000;
                        }
                    }else{
                        var elArrLength = arr0.length-1;
                        var startLength = $('#article-container > span:eq('+arr0[0].fatherIndex+') > span').length;
                        var num1 = 0;
                        var startType = false;
                        for(var i=0; i<startLength; i++){
                            if($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                num1++
                            }
                        }
                        if(num1 == startLength){
                            startType = true;
                        }
                        var endLength = $('#article-container > span:eq('+arr0[elArrLength].fatherIndex+') > span').length;
                        var num2 = 0;
                        var endType = false;
                        for(var i=0; i<endLength; i++){
                            if($('#article-container > span:eq('+arr0[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                num2++
                            }
                        }
                        if(num2 == endLength){
                            endType = true;
                        }
                        if(startType){
                            console.log(1)
                            if(arr0[0].fatherIndex==0){
                                saveBg = Number($('#article-container > span:eq(0) > span:eq(0)').attr('data-bg'))/1000;
                            }else{
                                var preNode = arr0[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                saveBg = Number($('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed'))/1000
                            }
                        }else{
                            console.log(2)
                            if(arr0[0].index == 0){
                                var preNode = arr0[0].fatherIndex - 1;
                                var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',that.clipDate[delNum].saveStartTime*1000)
                                saveBg = Number($('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed'))/1000
                            }else{
                                var pre = arr0[0].index - 1;
                                // console.log(pre)
                                saveBg = Number($('#article-container > span:eq('+arr0[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed'))/1000
                            }
                        }
                        if(endType){
                            console.log(3)
                            var nextNode = Number(arr0[elArrLength].fatherIndex) + 1;
                            saveEd = Number($('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg'))/1000
                        }else{
                            console.log(4)
                            if(Number(arr0[elArrLength].index) == $('#article-container > span:eq('+arr0[elArrLength].fatherIndex+') > span').length-1){
                                var nextP = Number(arr0[elArrLength].fatherIndex)+1
                                saveEd = Number($('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg'))/1000
                            }else{
                                var next = Number(arr0[elArrLength].index) + 1;
                                saveEd = Number($('#article-container > span:eq('+arr0[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg'))/1000
                            }
                        }
                    }

                    var delRegion = 'currentRegion'+Math.random()
                    that.currentRegion = that.wavesurfer.addRegion({
                            id: delRegion ,
                            start: Number(bg)/1000,
                            end: Number(ed)/1000,
                            loop: false,
                            drag: false,
                            resize: true,
                            color: "rgba(0, 0, 0, 0.4)"
                        });
                    that.clipDate.push({
                        type: 'del',
                        delRegion: delRegion,
                        startTime: Number(bg)/1000,
                        endTime: Number(ed)/1000,
                        saveStartTime: saveBg,
                        saveEndTime: saveEd,
                        arr: arr0
                    })
                })

                that.clipDate.forEach(function(el,index){
                    if(el.startTime >= bg && el.endTime <= ed) {
                        delNum1.push(index);
                        var regionLength = $('#audioPlayer > wave > region').length;
                        for(var i=0; i<regionLength; i++){
                            if($('#audioPlayer > wave > region')[i].dataset.id==el.delRegion){
                                $('#audioPlayer > wave > region:eq('+i+')').addClass('on');
                            }
                        }
                    }
                })

                for(var deli=delNum1.length-1; deli>=0; deli-- ){
                    that.clipDate.splice(delNum1[deli],1)
                }

                // console.log(that.clipDate);
            }

            // $('#audioPlayer > wave > region').click(function(){
            that.wavesurfer.on('region-update-end',function(e){
                // console.log(e)
                var maxSec = Number(that.maxSec)/1000;
                if(e.end > maxSec || e.end==undefined || e.end==null || e.end==''){
                    e.end=maxSec;
                }
                if(e.start < 0 || e.start==undefined || e.start==null || e.start==''){
                    e.start=0;
                }
                var left = e.start.toFixed(2);
                var width = e.end.toFixed(2);
                var id = e.id;
                // console.log(left,width,id);
                // console.log(that.clipDate)
                if(e.id.indexOf('currentRegion')==-1){
                    return false;
                }
                that.clipDate.forEach(function(el,index){
                    if(el.delRegion==id){
                        el.startTime = left
                        el.endTime = width
                        var len = el.arr.length;
                        if(len == 1){
                            if(el.arr[0].fatherIndex==0&&el.arr[0].index==0){
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-bg',el.startTime*1000)
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(0)').attr('data-ed',el.endTime*1000)
                            }else if(el.arr[0].index==0){
                                var preFatherIndex = el.arr[0].fatherIndex-1;
                                var preIndex = $('#article-contianer > span:eq('+preFatherIndex+') > span').length-1;
                                $('#article-container > span:eq('+preFatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq(1)').attr('data-ed',el.startTime*1000)
                            }else if(el.arr[0].index==$('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length-1){
                                var nextFatherIndex = el.arr[0].fatherIndex+1;
                                var preIndex = el.arr[0].index-1;
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+preIndex+')').attr('data-bg',el.endTime*1000)
                                $('#article-container > span:eq('+nextFatherIndex+') > span:eq(0)').attr('data-ed',el.startTime*1000)
                            }else{
                                var pre = el.arr[0].index - 1;
                                var next = el.arr[0].index + 1;
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                                $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                            }
                        }else{
                            var elArrLength = el.arr.length-1;
                            var startLength = $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span').length;
                            var num1 = 0;
                            var startType = false;
                            for(var i=0; i<startLength; i++){
                                if($('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                    num1++
                                }
                            }
                            if(num1 == startLength){
                                startType = true;
                            }
                            var endLength = $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length;
                            var num2 = 0;
                            var endType = false;
                            for(var i=0; i<endLength; i++){
                                if($('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+i+')').hasClass('on')){
                                    num2++
                                }
                            }
                            if(num2 == endLength){
                                endType = true;
                            }
                            if(startType){
                                console.log(1)
                                if(el.arr[0].fatherIndex==0){
                                    $('#article-container > span:eq(0) > span:eq(0)').attr('data-bg',el.startTime*1000)
                                }else{
                                    var preNode = el.arr[0].fatherIndex - 1;
                                    var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                    $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                                }
                            }else{
                                console.log(2)
                                if(el.arr[0].index == 0){
                                    var preNode = el.arr[0].fatherIndex - 1;
                                    var preLength = $('#article-container > span:eq('+preNode+') > span').length - 1;
                                    $('#article-container > span:eq('+preNode+') > span:eq('+preLength+')').attr('data-ed',el.startTime*1000)
                                }else{
                                    var pre = el.arr[0].index - 1;
                                    console.log(pre)
                                    $('#article-container > span:eq('+el.arr[0].fatherIndex+') > span:eq('+pre+')').attr('data-ed',el.startTime*1000)
                                }
                            }
                            if(endType){
                                console.log(3)
                                var nextNode = Number(el.arr[elArrLength].fatherIndex) + 1;
                                $('#article-container > span:eq('+nextNode+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                            }else{
                                console.log(4)
                                if(Number(el.arr[elArrLength].index) == $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span').length-1){
                                    var nextP = Number(el.arr[elArrLength].fatherIndex)+1
                                    $('#article-container > span:eq('+nextP+') > span:eq(0)').attr('data-bg',el.endTime*1000)
                                }else{
                                    var next = Number(el.arr[elArrLength].index) + 1;
                                    $('#article-container > span:eq('+el.arr[elArrLength].fatherIndex+') > span:eq('+next+')').attr('data-bg',el.endTime*1000)
                                }
                            }
                        }
                    }
                })
            })
        },
        blobToDataURI(blob, callback) {
            var reader = new FileReader();
            reader.onload = function (e) {
                callback(e.target.result);
            }
            reader.readAsDataURL(blob);
        },
        ArrayBufferToBase64 (buffer) { // ArrayBuffer转Base64
            var binary = ''
            var bytes = new Uint8Array(buffer)
            var len = bytes.byteLength
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i])
            }
            return window.btoa(binary)
        },
        updateView:function(newData) {
            var buf = this.audioBuffer;
            var ctx = this.wavesurfer.backend.ac;
            var newBuf = ctx.createBuffer(1, newData.length,buf.sampleRate);
            console.log(newData)
            newBuf.copyToChannel(newData, 0, 0);
            return newBuf
        },
        // 添加buffer
        insertBuffer(data,start,slice) {
            var newData = new Float32Array(data.length +  slice.length);
            var j = 0;
            for (var i = 0; i < start; i++) {
                newData[j++] = data[i];
            }
            for (var i = 0; i < slice.length; i++) {
                newData[j++] = slice[i];
            }
            for (var i = start; i < data.length; i++) {
                newData[j++] = data[i];
            }
            return newData;
        },
        // 绘制minimap
        draw() {
            var peaks = this.arr13;
            var canvas1 = document.getElementById('canvas1');
            var canvas2 = document.getElementById('canvas2');
            var ctx = canvas1.getContext('2d');
            var ctx1 = canvas2.getContext('2d');
            var parseIntWidth = parseInt(this.minimapWidth);
            ctx.clearRect(0,0,parseIntWidth,30);
            ctx1.clearRect(0,0,parseIntWidth,30);
            var pixelRatio = 1;
            var $ = 0.5 / pixelRatio;
            var height = 30 * pixelRatio;
            var offsetY = height * 0;
            var halfH = height / 2;
            var length = ~~(peaks.length / 2);

            var scale = 1;
            if (parseInt(this.minimapWidth) != length) {
                scale = parseInt(this.minimapWidth) / length;
            }

            var absmax = 1;
            ctx.fillStyle = '#999';
            ctx1.fillStyle = '#000';

            ctx.beginPath();
            ctx.moveTo($, halfH + offsetY);
            ctx1.beginPath();
            ctx1.moveTo($, halfH + offsetY);

            for (var i = 0; i < length; i++) {
                var h = Math.round(peaks[2 * i] / absmax * halfH);
                ctx.lineTo(i * scale + $, halfH - h + offsetY);
                ctx1.lineTo(i * scale + $, halfH - h + offsetY);
            }

            // Draw the bottom edge going backwards, to make a single
            // closed hull to fill.
            for (var i = length - 1; i >= 0; i--) {
                var h = Math.round(peaks[2 * i + 1] / absmax * halfH);
                ctx.lineTo(i * scale + $, halfH - h + offsetY);
                ctx1.lineTo(i * scale + $, halfH - h + offsetY);
            }

            ctx.closePath();
            ctx.fill();

            ctx1.closePath();
            ctx1.fill();

            // Always draw a median line
            ctx.fillRect(0,halfH + offsetY - $, this.minimapWidth, $);
            ctx1.fillRect(0,halfH + offsetY - $, this.minimapWidth, $);
        },

        // 鼠标点击区域的位置信息
        c() {
            var objLeft = this.getOffsetLeft(document.getElementsByClassName('miniMap-container')[0]);
            var mouseX = event.clientX-20;
            var objX = mouseX-objLeft;
            var width = document.body.clientWidth - objLeft - 40;
            var left = objX/width * 100 + '%';
            var nowWidth = width*(objX/width);
            this.nowWidth = nowWidth+'px';
            var nowTime = this.totalDuration1 * (objX/width);
            if(nowTime>this.saveCurrentTimeClick){
                var time = nowTime - this.saveCurrentTimeClick;
                this.wavesurfer.skipForward(time);
                this.saveCurrentTimeClick = nowTime;
            }else{
                var time = this.saveCurrentTimeClick - nowTime;
                this.wavesurfer.skipBackward(time);
                this.saveCurrentTimeClick = nowTime;
            }
        },
        getOffsetLeft(obj) {
            var tmp = obj.offsetLeft;
            var val = obj.offsetParent;
            while(val != null){
                tmp += val.offsetLeft;
                val = val.offsetParent;
            }
            return tmp;
        },
        skipStart() {
            if(this.wavesurfer!=null&&this.wavesurfer!=undefined&&this.wavesurfer!=''){
                clearInterval(this.time)
                clearInterval(this.time1)
                clearInterval(this.time2)
                clearInterval(this.time3)
                this.wavesurfer.pause();
                this.isPlay = false;
                var time = this.wavesurfer.getCurrentTime();
                this.wavesurfer.skipBackward(time);
                this.nowWidth = '0px';
                this.saveCurrentTimeClick = 0;
                $('#zmContainer > div').removeClass('on');
            }
        },
        skipEnd() {
            if(this.wavesurfer!=null&&this.wavesurfer!=undefined&&this.wavesurfer!=''){
                clearInterval(this.time)
                clearInterval(this.time1)
                clearInterval(this.time2)
                clearInterval(this.time3)
                this.wavesurfer.pause();
                this.isPlay = false;
                var time = this.wavesurfer.getCurrentTime();
                var duration = this.wavesurfer.getDuration();
                time = duration - time;
                this.wavesurfer.skip(time);
                var objLeft = this.getOffsetLeft(document.getElementsByClassName('miniMap-container')[0]);
                var width = document.body.clientWidth - objLeft - 40;
                this.nowWidth = width+'px';
                this.saveCurrentTimeClick = width;
                $('#zmContainer > div').removeClass('on');
            }
        },
        selectBtn() {
            this.ee.emit("pause");
        },

        trimBtn() {
            this.ee.emit("trim");
        },

        playAudioPlay() {
            this.ee.emit('play')
        },

        downloadfile() {
            this.ee.emit('startaudiorendering', 'wav');
        },

        // 判断跳过时间点
        clipBtn1(time) {
            var that = this;
            this.clipDate.forEach(function(val,index){
                if(time >= val.startTime && time < val.endTime){
                    if(val.type == 'del'){
                        if(val.endTime==Number(that.maxSec)/1000){
                            if(that.nowMax){
                                console.log(1)
                                clearInterval(that.time);
                                if(that.oneClick || that.twoClick){
                                    that.nowMax = false;
                                    that.wavesurfer.stop()
                                    that.wavesurfer.playPause();
                                    setTimeout(function(){
                                        that.isPlay = true;
                                        that.time = setInterval(function(){
                                            that.currentTime();
                                        })
                                    },500)
                                    that.oneClick = false;
                                    that.twoClick = false;
                                }else{
                                    console.log(2)
                                    that.nowMax = false;
                                    that.wavesurfer.stop()
                                    that.wavesurfer.playPause();
                                    that.isPlay = true;
                                    that.time = setInterval(function(){
                                        that.currentTime();
                                    })
                                }
                            }else{
                                console.log(3)
                                that.wavesurfer.pause()
                                clearInterval(that.time);
                                that.isPlay = false;
                                that.nowMax = true;
                                $('#article-container > span').removeClass('on');
                            }
                        }else{
                            console.log(4)
                            var skipTime = val.endTime - time;
                            that.wavesurfer.skip(skipTime)
                            setTimeout(function(){
                                that.isPlay = true;
                            })
                        }
                    }else{
                        that.currentRegion = that.wavesurfer.addRegion({
                            id: 'currentRegion',
                            start: val.regionStart,
                            end: val.regionEnd,
                            loop: false,
                            drag: false,
                            resize: false,
                            color: "rgba(254, 255, 255, 0)"
                        });
                        that.regionPlay = true;
                        that.endTime1 = val.endTime;
                        that.regionEnd1 = val.regionEnd;
                        that.currentRegion.play();
                    }
                }
            })
        },

        // 当前时间
        currentTime() {
            var that = this;
            this.$emit('nowTime',{
                time: that.wavesurfer.getCurrentTime()
            })
            var objLeft = this.getOffsetLeft(document.getElementsByClassName('miniMap-container')[0]);
            var width = document.body.clientWidth - objLeft - 40;
            this.nowWidth = width * (this.wavesurfer.getCurrentTime()/this.wavesurfer.getDuration()) + 'px';
            if(this.regionPlay){
                var time = that.wavesurfer.getCurrentTime();
                if(time >= this.regionEnd1){
                    var seekTime = this.endTime1-time;
                    this.wavesurfer.skip(seekTime);
                    this.wavesurfer.play();
                    this.regionPlay = false;
                }
            }else{
                that.clipBtn1(that.wavesurfer.getCurrentTime());
            }
            that.zmContent.forEach(function(el,index){
                var bg = Number(el.bg)/1000;
                var ed = Number(el.ed)/1000;
                console.log(that.wavesurfer.getCurrentTime(),bg)
                if(that.wavesurfer.getCurrentTime()>=bg && that.wavesurfer.getCurrentTime()<=ed){
                    if(index!=that.oldIndex){
                        $('#zmContainer > div').removeClass('on');
                        $('#zmContainer > div:eq('+index+')').addClass('on');
                        that.oldIndex = index;
                    }
                }
            })
        },

        wordTime() {

        },

        // 源生音频播放器当前时间
        audiocurrentTime() {
            var that = this;
            var percent = (this.audio.currentTime/this.duration)*100 + '%';
            this.left = percent;
        },

        // 音频播放按钮
        playAudio() {
            var that = this;
            if(this.isAudioPlayer){
                if(this.isPlay==false){
                    this.audio.play();
                    this.time = setInterval(function(){
                        that.audiocurrentTime();
                    },1000)
                }else{
                    this.audio.pause();
                    clearInterval(that.time);
                }
            }else{
                this.wavesurfer.playPause();
                if(this.isPlay==false){
                    this.time = setInterval(function(){
                        that.currentTime();
                    })
                }else{
                    clearInterval(that.time);
                    clearInterval(that.time2);
                    clearInterval(that.time3);
                }
            }
        },

        // 初始化wavesurfer配置
        setWavesurfer(val,newDuration) {
            var that = this;
            if(this.wavesurfer!=''&&this.wavesurfer!=undefined&&this.wavesurfer!=null){
                this.wavesurfer.destroy();
            }
            if(newDuration!=null&&newDuration!=undefined&&newDuration!=''){
                this.wavesurfer = WaveSurfer.create({
                    container: '#audioPlayer',
                    waveColor: '#39CFB1',
                    progressColor: '#539084',
                    backend: 'MediaElement',
                    minPxPerSec: 100,
                    height: 130,
                    scrollParent: true,
                    hideScrollbar: false,
                    plugins: [
                        WaveSurfer.regions.create({

                        }),
                        WaveSurfer.timeline.create({
                            container: '#audioTimeLine',
                            duration: newDuration
                        })
                    ]
                })
            }else{
                this.wavesurfer = WaveSurfer.create({
                    container: '#audioPlayer',
                    waveColor: '#39CFB1',
                    progressColor: '#539084',
                    backend: 'MediaElement',
                    minPxPerSec: 100,
                    height: 130,
                    scrollParent: true,
                    hideScrollbar: false,
                    plugins: [
                        WaveSurfer.regions.create({

                        }),
                        WaveSurfer.timeline.create({
                            container: '#audioTimeLine'
                        }),
                    ]
                })
            }

            that.wavesurfer.empty();
            if(that.arr12.length > 0){
                setTimeout(function(){
                    that.wavesurfer.load(val,that.arr12);
                    var audioCtx = new AudioContext();
                    function getData() {
                        var request = new XMLHttpRequest();
                        request.open('GET', val, true);
                        request.responseType = 'arraybuffer';
                        request.onload = function() {
                            let audioData = request.response;
                            audioCtx.decodeAudioData(audioData, function(buffer) {
                                that.audioBuffer = buffer;
                                that.audioBufferDate = buffer.getChannelData(0);
                            })
                        }
                        request.send();
                    }
                    getData();
                },500)
            }else{
                that.wavesurfer.load(val);
            }

            // wavesurfer ready加载region区域
            this.wavesurfer.on('ready',function(e){
                that.canPlay = false;
                that.totalDuration1 = that.wavesurfer.getDuration();
                that.totalDurationSave = that.wavesurfer.getDuration();
                that.enableResize = that.wavesurfer.enableDragSelection({
                    loop: false,
                    drag: false,
                    resize: true,
                    color: "rgba(0, 0, 0, 0.4)"
                })
                // region区域点击事件
                $('#audioPlayer > wave').click(function(){
                    that.wavesurfer.pause()
                    that.isPlay = false;
                    setTimeout(function(){
                        var minimapWidth = parseInt(that.minimapWidth);
                        var durationTime = that.wavesurfer.getDuration();
                        var wordTime = that.wavesurfer.getCurrentTime();
                        var nowWidth = minimapWidth * (wordTime/durationTime) + 'px';
                        that.saveCurrentTimeClick = wordTime;
                        that.nowWidth = nowWidth;
                        if(wordTime<that.zmBg && wordTime<that.zmEd&&that.zmRegion!=null){
                            that.playdbl = false;
                            that.zmRegion.remove()
                        }else if(wordTime>that.zmEd&&that.zmRegion!=null){
                            that.playdbl = false;
                            that.zmRegion.remove()
                        }
                    })
                })

                // region区域更新事件
                that.wavesurfer.on('region-update-end',function(e){

                    // 设置最大最小区域，当时间未知时赋值
                    var maxSec = Number(that.maxSec)/1000;
                    if(e.end==undefined || e.end==null || e.end==''){
                        e.end=maxSec;
                    }
                    if(e.start < 0 || e.start==undefined || e.start==null || e.start==''){
                        e.start=0;
                    }
                    if(e.start>e.end){
                        e.start = Number(e.element.offsetLeft)/100;
                        e.end = Number(e.element.offsetLeft)/100 + Number(e.element.clientWidth)/100;
                    }

                    // 设置时间保留两位小数
                    var left = e.start.toFixed(2);
                    var width = e.end.toFixed(2);
                    var resizeId = e.id;
                    var isRegion = false;
                    var regionIndex = '';
                    var delNum9 = [];
                    that.clipDate.forEach(function(el,index){
                        if(el.delRegion==resizeId){
                            isRegion = true;
                            regionIndex = index;
                        }
                    })

                    // 更新跳过时间的开始时间与结束时间
                    if(e.id.indexOf('wavesurfer')!=-1){
                        if(isRegion){
                            that.clipDate[regionIndex].startTime = left;
                            that.clipDate[regionIndex].endTime = width;
                        }else{
                            that.clipDate.forEach(function(val,key){
                                if(val.blank==1){
                                    if(left<=val.startTime&&width>=val.endTime){
                                        delNum9.push(key)
                                    }else if(left>=val.startTime&&left<=val.endTime&&width>val.endTime){
                                        left = val.startTime
                                        delNum9.push(key)
                                        var len99 = $('#audioPlayer > wave > region').length;
                                        for(var j=0; j<len99; j++){
                                            if($('#audioPlayer > wave > region:eq('+j+')').attr('data-id')==resizeId){
                                                $('#audioPlayer > wave > region:eq('+j+')').addClass('on')
                                            }
                                        }
                                        resizeId = 'wavesurfer'+Math.random();
                                        that.addRegion = that.wavesurfer.addRegion({
                                            id: resizeId,
                                            start: left,
                                            end: width,
                                            loop: false,
                                            drag: false,
                                            resize: true,
                                            color: "rgba(0, 0, 0, 0.4)"
                                        });
                                    }else if(left<val.startTime&&width>=val.startTime&&width<=val.endTime){
                                        width = val.endTime
                                        delNum9.push(key)
                                        var len99 = $('#audioPlayer > wave > region').length;
                                        for(var j=0; j<len99; j++){
                                            if($('#audioPlayer > wave > region:eq('+j+')').attr('data-id')==resizeId){
                                                $('#audioPlayer > wave > region:eq('+j+')').addClass('on')
                                            }
                                        }
                                        resizeId = 'wavesurfer'+Math.random();
                                        that.addRegion = that.wavesurfer.addRegion({
                                            id: resizeId,
                                            start: left,
                                            end: width,
                                            loop: false,
                                            drag: false,
                                            resize: true,
                                            color: "rgba(0, 0, 0, 0.4)"
                                        });
                                    }else if(left>=val.startTime&&width<=val.endTime){
                                        return
                                    }
                                }
                            })

                            // 合并重复段落

                            var len99 = $('#audioPlayer > wave > region').length;

                            for(var i=delNum9.length-1;i>=0;i--){
                                for(var j=0; j<len99; j++){
                                    if($('#audioPlayer > wave > region:eq('+j+')').attr('data-id')==that.clipDate[delNum9[i]].delRegion){
                                        $('#audioPlayer > wave > region:eq('+j+')').addClass('on')
                                    }
                                }
                                that.clipDate.splice(delNum9[i],1)
                            }
                            that.clipDate.push({
                                type: 'del',
                                startTime: left,
                                endTime: width,
                                delRegion: resizeId,
                                arr: [],
                                blank: 1
                            })
                        }
                        that.regionLeft = left;
                        that.regionWidth = width;
                    }
                })

            })

            // wavesurfer seek事件
            this.wavesurfer.on('seek',function(e){
                var wordTime = that.wavesurfer.getCurrentTime();
                if(that.playdbl){
                    if(wordTime<that.zmBg && wordTime<that.zmEd){
                        clearInterval(that.time1);
                        setTimeout(function(){
                            that.isPlay = false;
                        })
                    }else if(wordTime>=that.zmBg && wordTime<=that.zmEd){
                        setTimeout(function(){
                            that.isPlay = false;
                        })
                    }
                }else{
                    clearInterval(that.time1);
                }

                // region 双击删除事件
                $('#audioPlayer > wave > region').dblclick(function(){
                    var resizeId = $(this).attr('data-id');
                    if(resizeId.indexOf('wavesurfer')!=-1){
                        var regionIndex = '';
                        var canRegion = false;
                        that.clipDate.forEach(function(el,index){
                            if(el.delRegion==resizeId){
                                regionIndex = index;
                                canRegion = true;
                            }
                        })
                        if(canRegion){
                            $(this).addClass('on');
                            that.clipDate.splice(regionIndex,1);
                            canRegion = false;
                        }
                    }
                })
            })

            // wavesurfer pause暂停事件
            this.wavesurfer.on('pause',function(){
                if(that.playdbl){
                    that.isPlay = false;
                }
            })

            // wavesurfer finish播放结束事件
            this.wavesurfer.on('finish',function(){
                that.wavesurfer.pause()
                clearInterval(that.time);
                that.isPlay = false;
            })
        },
        createTimeLine() {
            var duration = this.duration;
        },

        // 时间格式转换
        formatDuration(val, formatStr) {
            const prefix = function (val) {
                if (val < 10) {
                    return "0" + val;
                } else {
                    return val;
                }
            };

            window.Moment = moment;

            let duration = Moment.duration(val);

            if (formatStr.match("hh")) {
                formatStr = formatStr.replace("hh", prefix(duration.get("hours")));
                formatStr = formatStr.replace("mm", prefix(duration.get("minutes")));
            } else {
                formatStr = formatStr.replace("mm", prefix(Math.floor(duration.asMinutes())));
            }
            formatStr = formatStr.replace("ss", prefix(duration.get("seconds")));

            return formatStr;
        },

        getBuffer(src) {
            var that = this;
            var request = new XMLHttpRequest();
            request.open('GET',src,true)
            request.responseType = 'arraybuffer';
            request.onload = function() {
                var audioData = request.response;
                console.log(audioData)
                that.audioContext.decodeAudioData(audioData,function(buffer){
                    console.log(buffer)
                    that.loadBuffer(buffer)
                })
            }
            request.send()
        },

        clipBufferSource:function (addr,min,max) {//歌曲地址，开始时间，结束时间
            var that = this;
            this.min = min;
            this.max = max;
            if (this.xhrSource) {
                this.xhrSource.disconnect(0);
            }
            this.audioContext = new AudioContext;
            this.xhrSource = this.audioContext.createBufferSource();
            this.pNode = this.audioContext.createScriptProcessor(4096,1,1);

            this.getBuffer(addr);//获取音频数据

            that.buffer = [];
            console.log(this.pNode)
            this.pNode.onaudioprocess = function (e) {

                var ct = ~~that.audioContext.currentTime;

                if(ct >= that.max){
                    that.stopBufferSource()
                    that.saveClipSong();
                }
                if (ct <= that.min || ct >= that.max) {return;}

                // The input buffer is the song we loaded earlier
                var inputBuffer = e.inputBuffer;

                // The output buffer contains the samples that will be modified and played
                var outputBuffer = e.outputBuffer;

                // Loop through the output channels (in this case there is only one)
                for (var channel = 0; channel < outputBuffer.numberOfChannels; channel++) {
                    var inputData = inputBuffer.getChannelData(channel);
                    var outputData = outputBuffer.getChannelData(channel);
                    var bufferData = [];
                    // Loop through the 4096 samples
                    for (var sample = 0; sample < inputBuffer.length; sample++) {
                      // make output equal to the same as the input
                      outputData[sample] = inputData[sample];
                      bufferData[sample] = inputData[sample];
                    }
                    if (ct >= that.min && ct <= that.max){
                        that.buffer.push(bufferData);
                    }

                }
            }
        },

        loadBuffer:function (data) {
            this.xhrSource.buffer = data;
            this.xhrSource.connect(this.pNode);
            this.pNode.connect(this.audioContext.destination);
            // this.xhrSource.start(this.min,this.max-this.min,this.max-this.min);
            this.xhrSource.start(0,20)
        },

        stopBufferSource:function () {
            this.xhrSource.disconnect()
            this.pNode.disconnect(this.audioContext.destination);
            this.xhrSource.stop();
        },

        saveClipSong: function () {
            var data = this.buffer;
            var frequency=this.audioContext.sampleRate; //采样频率
            var pointSize=16; //采样点大小
            var channelNumber=1; //声道数量
            var blockSize=channelNumber*pointSize/8; //采样块大小
            var wave=[]; //数据
            for(var i=0;i<data.length;i++)
              for(var j=0;j<data[i].length;j++)
                wave.push(data[i][j]*0x8000|0);
            var length=wave.length*pointSize/8; //数据长度
            var buffer=new Uint8Array(length+44); //wav文件数据
            var view=new DataView(buffer.buffer); //数据视图
            buffer.set(new Uint8Array([0x52,0x49,0x46,0x46])); //"RIFF"
            view.setUint32(4,data.length+44,true); //总长度
            buffer.set(new Uint8Array([0x57,0x41,0x56,0x45]),8); //"WAVE"
            buffer.set(new Uint8Array([0x66,0x6D,0x74,0x20]),12); //"fmt "
            view.setUint32(16,16,true); //WAV头大小
            view.setUint16(20,1,true); //编码方式
            view.setUint16(22,1,true); //声道数量
            view.setUint32(24,frequency,true); //采样频率
            view.setUint32(28,frequency*blockSize,true); //每秒字节数
            view.setUint16(32,blockSize,true); //采样块大小
            view.setUint16(34,pointSize,true); //采样点大小
            buffer.set(new Uint8Array([0x64,0x61,0x74,0x61]),36); //"data"
            view.setUint32(40,length,true); //数据长度
            buffer.set(new Uint8Array(new Int16Array(wave).buffer),44); //数据
            //打开文件
            var blob=new Blob([buffer],{type:"audio/mp3"});
            // console.log('blob',blob)
            var src = URL.createObjectURL(blob);
            $('body').append('<a href="'+src+'" download="filename"> download the cliped song</a>');
        },

        clipBtn: function () {
            var that = this;
            that.clipBufferSource(this.filePathUrl,0,10);
        }
    },
    beforeDestroy: function() {
        clearInterval(this.getscrollBar);
        clearInterval(this.time);
        clearInterval(this.time1);
        clearInterval(this.time2);
        clearInterval(this.time3);
        clearInterval(this.time4);
        if(this.wavesurfer!=''&&this.wavesurfer!=null&&this.wavesurfer!=undefined){
            this.wavesurfer.empty();
            this.wavesurfer.destroy();
        }
    },
    destroyed: function() {
        clearInterval(this.getscrollBar);
        clearInterval(this.time);
        clearInterval(this.time1);
        clearInterval(this.time2);
        clearInterval(this.time3);
        clearInterval(this.time4);
        if(this.wavesurfer!=''&&this.wavesurfer!=null&&this.wavesurfer!=undefined){
            this.wavesurfer.empty();
            this.wavesurfer.destroy();
        }
    },
    computed: {
    //   voiceOptionNew() {
    //     return JSON.parse(JSON.stringify(this.voiceOption))
    //   }
    },
    watch: {
        editConfig(to,from){
            this.getaudioEvent(to);
        },
        voiceOptionNew: {
            deep: true,
            handler: function (newVal,oldVal){
                if(newVal.src&&newVal.src!=oldVal.src){
                    console.log(newVal.src,oldVal.src)
                    this.getaudioEvent(newVal.src);
                }else if(newVal.setDelInfo&&newVal.setDelInfo!=oldVal.setDelInfo){
                    this.setDelInfoEvent(newVal.setDelInfo);
                }else if(newVal.submitContent&&newVal.submitContent!=oldVal.submitContent){
                    this.submitContentEvent(newVal.submitContent);
                }else if(newVal.resumeDel&&newVal.resumeDel!=oldVal.resumeDel){
                    this.resumeDelEvent(newVal.resumeDel);
                }else if(newVal.setClipDate&&newVal.setClipDate!=oldVal.setClipDate){
                    this.setClipDateEvent(newVal.setClipDate);
                }else if(newVal.maxSecProp&&newVal.maxSecProp!=oldVal.maxSecProp){
                    this.maxSecEvent(newVal.maxSecProp);
                }else if(newVal.dblPlay&&newVal.dblPlay!=oldVal.dblPlay){
                    this.dblPlayEvent(newVal.dblPlay);
                }else if(newVal.playPauseAudio&&newVal.playPauseAudio!=oldVal.playPauseAudio){
                    this.playPauseAudioEvent(newVal.playPauseAudio);
                }
            }
        },
        clipDate(to,from){
            this.$emit('getClipDate',{
                clipDate: to
            })
        },
        playdbl(to,from){
           
        },
        minimapWidth(to,from){
            
        },
        changeClientWidth(to,from){
            var that = this;
            setTimeout(function(){
              var minimapWidth = $('.bottom-mask').width();
              that.minimapWidth = minimapWidth - 40 + 'px';
            },1000)
            setTimeout(function(){
                that.draw();
            },1000)
        },
        setDelInfo(to){
            this.setDelInfoEvent(to);
        },
        submitContent(to){
            this.submitContentEvent(to);
        },
        resumeDel(to){
            this.resumeDelEvent(to);
        },
        src(to){
            this.getaudioEvent(to);
        },
        setClipDate(to){
            this.setClipDateEvent(to);
        },
        maxSecProp(to){
            this.maxSecEvent(to);
        },
        dblPlay(to){
            this.dblPlayEvent(to);
        },
        setCopyInfo(to){
            this.setCopyInfoEvent(to);
        },
        stopaudio(to){
            this.stopaudioEvent();
        },
        resumeaudio(to){
            this.resumeaudioEvent();
        },
        playPauseAudio(to){
            this.playPauseAudioEvent();
        }
    },
    mounted() {
        var that = this;
        var audio;

        // 初始化源生audio组件
        setTimeout(function(){
            audio = document.getElementsByTagName('audio')[0];
            that.audio = audio;
        })

        var time = null;
        var wavesurfer;
        this.time = time;
        this.wavesurfer = wavesurfer;
        (function (doc, win) {

            var docEl = doc.documentElement,

                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',

                recalc = function () {

                    var clientWidth = docEl.clientWidth;

                    if (!clientWidth) {

                        return;
                    }

                    that.changeClientWidth = clientWidth;
                };

            if (!doc.addEventListener) {

                return;
            }
            win.addEventListener(resizeEvt, recalc, false);

            doc.addEventListener('DOMContentLoaded', recalc, false);

        })(document, window);

        // 设置波形图滚动条随时间滚动
        this.getscrollBar = setInterval(function(){
            var x = $('#audioPlayer > wave').scrollLeft()
            $('#audioWord').scrollLeft(x);
        })

    },
    created() {
        var that = this;
    }
}
</script>

<style scoped>
    .voiceEditBtn {
        display: flex;
        flex-direction: column;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
    }

    .voiceBtn-container {
        
        /* padding: 20px 0; */
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        /* min-height: 284px; */
        background: rgba(0,0,0,0.4);
        box-sizing: border-box;
        /* margin-bottom: 30px; */
    }

    .audio-btn {
        justify-content: center;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .audio-btn .play {
        position: relative;
        padding: 0px;
        width: 38px;
        height: 38px;
    }

    .audio-btn .play i.play {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -6px;
        margin-left: -7px;
        display: block;
        width: 12px;
        height: 12px;
        background: url('../assets/play.png') no-repeat;
        background-size: 100%;
        background-position: 2px center;
    }

    .audio-btn .play i.pause {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -8px;
        margin-left: -7px;
        display: block;
        width: 16px;
        height: 16px;
        background: url('../assets/pause.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .el-button.transparent {
        background: transparent;
        border: 1px solid transparent;
        padding: 0px;
        box-sizing: border-box;
    }

    .el-button i.pre {
        display: block;
        width: 28px;
        height: 28px;
        background: url('../assets/pre.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .el-button i.next {
        display: block;
        width: 28px;
        height: 28px;
        background: url('../assets/next.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .btnEdit-contianer {
        background: rgba(0,0,0,0.4);
    }

    .btn-container {
        /* width: 10%; */
        /* margin-top: 8px;
        margin-bottom: 4px; */
        /* padding: 10px 0 10px 0; */
        position: relative;
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        background: rgba(0,0,0,0.3);
    }

    .btn-container .left-btn {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .btn-container .left-btn .el-button {
        width: 70px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
        border-radius: 4px;
        background: #56BCDE;
        color: #FFF;
        margin-right: 20px;
        user-select: none;
        cursor: pointer;
    }

    .btn-container .left-btn .notice {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 14px;
    }

    .btn-container .left-btn .notice img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }

    .btn-container .left-btn .notice span {
        font-size: 14px;
        line-height: 14px;
        color: #39CFB1;
    }

    .btn-container .mid-btn {
        position: absolute;
        left: 50%;
        margin-left: -66px;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 132px;
    }

    .btn-container .right-btn {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .btn-container .right-btn .el-button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 30px;
        border-radius: 4px;
        background: #39CFB1;
        cursor: pointer;
        user-select: none;
    }

    .btn-container .right-btn .el-button img {
        width: 16px;
        height: 15px;
        margin-right: 10px;
    }

    .btn-container .right-btn .el-button span {
        font-size: 14px;
        color: #FFF;
    }

    .btn-container img {
        width: 28px;
        height: 28px;
    }

    .btn-container .leftArrow {
        width: 14px;
        height: 12px;
        margin-right: 38px;
        cursor: pointer;
    }

    .btn-container .rightArrow {
        width: 14px;
        height: 12px;
        margin-left: 38px;
        cursor: pointer;
    }

    #audioPlayer {
        /* height: 90px; */
        height: 130px;
    }

    #audioPlayer wave::-webkit-scrollbar {
        height: 0px !important;
    }

    #audioPlayer1 {
        display: none;
        position: relative;
        height: 100px;
        display: flex;
        align-items: center;
    }

    #audioPlayer1 .line {
        width: 100%;
        height: 1px;
        background: #A8DBA8;
        line-height: 100px;
    }

    #audioPlayer1 .lineOn {
        position: absolute;
        left: 0px;
        width: 0%;
        height: 1px;
        background: #3B8686;
        line-height: 100px;
    }

    #audioPlayer1 .point {
        position: absolute;
        top: 0px;
        left: 0%;
        height: 100px;
        width: 1px;
        background: rgb(51,51,51);
    }

    #audioPlay {
        width: 100%;
    }

    #audioTimeLine {
        position: absolute;
        /* top: 114px; */
        left: 0px;
        width: 100%;
        /* padding: 0px 50px; */
        box-sizing: border-box;
    }

    #audioWord {
        position: relative;
        padding: 0 50px;
        font-size: 12px;
        color: #fff;
        background: rgba(0,0,0,0.3);
        box-sizing: border-box;
        overflow: hidden;
        /* overflow-x: scroll; */
    }

    /* .minimap {
        background: rgba(0,0,0,0.3);
    } */

    .bottom-mask {
        position: absolute;
        width: 100%;
        /* height: 48px; */
        bottom: 80px;
        z-index: 1;
        background: rgba(0,0,0,0.5);
    }

    .miniMap-container {
        position: absolute;
        bottom: 80px;
        width: 100%;
        height: 30px;
        z-index: 99;
        background: transparent;
    }

    #canvas1 {
        position: absolute;
        left: 20px;
        bottom: 0px;
        z-index: 1;
    }

    #wave1 {
        position: absolute;
        left: 20px;
        bottom: 0px;
        z-index: 2;
        border-right: 1px solid #333;
        box-sizing: border-box;
    }
</style>

<style>
    /* .playlist .selection.point {
        background: red;
    }
    .cursor {
        background: red;
    } */
    /*滚动条样式*/
    #audioPlayer wave::-webkit-scrollbar {/*滚动条整体样式*/
        width: 8px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 8px;
    }
    #audioPlayer wave::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    #audioPlayer wave::-webkit-scrollbar-track {/*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }

    /*滚动条样式*/
    #audioWord::-webkit-scrollbar {/*滚动条整体样式*/
        width: 1px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }
    #audioWord::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
        border-radius: 1px;
        -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    #audioWord::-webkit-scrollbar-track {/*滚动条里面轨道*/
        box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }

    .selection.segment {
        background: rgba(0,0,0,0.1);
    }

    #audioPlayer > wave > wave {
        border-right: 2px solid #FFCB3C !important;
    }

    /* .minimap {
        background: rgba(0,0,0,0.3);
    } */

    #zmContainer {
        width: 1000000px;
        position: absolute;
        top: 3px;
        /* left: 50px; */
    }

    #zmContainer > div.on {
        background: #56BCDE !important;
    }

    #zmContainer > div > span.on {
        text-decoration: line-through;
        color: #919BA0;
    }

    #audioPlayer wave region.on {
        display: none !important;
    }

    #audioPlayer wave region.zIndex {
        z-index: 1 !important;
    }
</style>
